var items = {
  "block.minecraft.acacia_button": "金合欢木按钮",
  "block.minecraft.acacia_door": "金合欢木门",
  "block.minecraft.acacia_fence": "金合欢木栅栏",
  "block.minecraft.acacia_fence_gate": "金合欢木栅栏门",
  "block.minecraft.acacia_hanging_sign": "悬挂式金合欢木告示牌",
  "block.minecraft.acacia_leaves": "金合欢树叶",
  "block.minecraft.acacia_log": "金合欢原木",
  "block.minecraft.acacia_planks": "金合欢木板",
  "block.minecraft.acacia_pressure_plate": "金合欢木压力板",
  "block.minecraft.acacia_sapling": "金合欢树苗",
  "block.minecraft.acacia_shelf": "金合欢木展示架",
  "block.minecraft.acacia_sign": "金合欢木告示牌",
  "block.minecraft.acacia_slab": "金合欢木台阶",
  "block.minecraft.acacia_stairs": "金合欢木楼梯",
  "block.minecraft.acacia_trapdoor": "金合欢木活板门",
  "block.minecraft.acacia_wall_hanging_sign": "墙上的悬挂式金合欢木告示牌",
  "block.minecraft.acacia_wall_sign": "墙上的金合欢木告示牌",
  "block.minecraft.acacia_wood": "金合欢木",
  "block.minecraft.activator_rail": "激活铁轨",
  "block.minecraft.air": "空气",
  "block.minecraft.allium": "绒球葱",
  "block.minecraft.amethyst_block": "紫水晶块",
  "block.minecraft.amethyst_cluster": "紫水晶簇",
  "block.minecraft.ancient_debris": "远古残骸",
  "block.minecraft.andesite": "安山岩",
  "block.minecraft.andesite_slab": "安山岩台阶",
  "block.minecraft.andesite_stairs": "安山岩楼梯",
  "block.minecraft.andesite_wall": "安山岩墙",
  "block.minecraft.anvil": "铁砧",
  "block.minecraft.attached_melon_stem": "结果的西瓜茎",
  "block.minecraft.attached_pumpkin_stem": "结果的南瓜茎",
  "block.minecraft.azalea": "杜鹃花丛",
  "block.minecraft.azalea_leaves": "杜鹃树叶",
  "block.minecraft.azure_bluet": "蓝花美耳草",
  "block.minecraft.bamboo": "竹子",
  "block.minecraft.bamboo_block": "竹块",
  "block.minecraft.bamboo_button": "竹按钮",
  "block.minecraft.bamboo_door": "竹门",
  "block.minecraft.bamboo_fence": "竹栅栏",
  "block.minecraft.bamboo_fence_gate": "竹栅栏门",
  "block.minecraft.bamboo_hanging_sign": "悬挂式竹告示牌",
  "block.minecraft.bamboo_mosaic": "竹马赛克",
  "block.minecraft.bamboo_mosaic_slab": "竹马赛克台阶",
  "block.minecraft.bamboo_mosaic_stairs": "竹马赛克楼梯",
  "block.minecraft.bamboo_planks": "竹板",
  "block.minecraft.bamboo_pressure_plate": "竹压力板",
  "block.minecraft.bamboo_sapling": "竹笋",
  "block.minecraft.bamboo_shelf": "竹展示架",
  "block.minecraft.bamboo_sign": "竹告示牌",
  "block.minecraft.bamboo_slab": "竹台阶",
  "block.minecraft.bamboo_stairs": "竹楼梯",
  "block.minecraft.bamboo_trapdoor": "竹活板门",
  "block.minecraft.bamboo_wall_hanging_sign": "墙上的悬挂式竹告示牌",
  "block.minecraft.bamboo_wall_sign": "墙上的竹告示牌",
  "block.minecraft.banner.base.black": "黑底",
  "block.minecraft.banner.base.blue": "蓝底",
  "block.minecraft.banner.base.brown": "棕底",
  "block.minecraft.banner.base.cyan": "青底",
  "block.minecraft.banner.base.gray": "灰底",
  "block.minecraft.banner.base.green": "绿底",
  "block.minecraft.banner.base.light_blue": "淡蓝底",
  "block.minecraft.banner.base.light_gray": "淡灰底",
  "block.minecraft.banner.base.lime": "黄绿底",
  "block.minecraft.banner.base.magenta": "品红底",
  "block.minecraft.banner.base.orange": "橙底",
  "block.minecraft.banner.base.pink": "粉红底",
  "block.minecraft.banner.base.purple": "紫底",
  "block.minecraft.banner.base.red": "红底",
  "block.minecraft.banner.base.white": "白底",
  "block.minecraft.banner.base.yellow": "黄底",
  "block.minecraft.banner.border.black": "黑色方框边",
  "block.minecraft.banner.border.blue": "蓝色方框边",
  "block.minecraft.banner.border.brown": "棕色方框边",
  "block.minecraft.banner.border.cyan": "青色方框边",
  "block.minecraft.banner.border.gray": "灰色方框边",
  "block.minecraft.banner.border.green": "绿色方框边",
  "block.minecraft.banner.border.light_blue": "淡蓝色方框边",
  "block.minecraft.banner.border.light_gray": "淡灰色方框边",
  "block.minecraft.banner.border.lime": "黄绿色方框边",
  "block.minecraft.banner.border.magenta": "品红色方框边",
  "block.minecraft.banner.border.orange": "橙色方框边",
  "block.minecraft.banner.border.pink": "粉红色方框边",
  "block.minecraft.banner.border.purple": "紫色方框边",
  "block.minecraft.banner.border.red": "红色方框边",
  "block.minecraft.banner.border.white": "白色方框边",
  "block.minecraft.banner.border.yellow": "黄色方框边",
  "block.minecraft.banner.bricks.black": "黑色砖纹",
  "block.minecraft.banner.bricks.blue": "蓝色砖纹",
  "block.minecraft.banner.bricks.brown": "棕色砖纹",
  "block.minecraft.banner.bricks.cyan": "青色砖纹",
  "block.minecraft.banner.bricks.gray": "灰色砖纹",
  "block.minecraft.banner.bricks.green": "绿色砖纹",
  "block.minecraft.banner.bricks.light_blue": "淡蓝色砖纹",
  "block.minecraft.banner.bricks.light_gray": "淡灰色砖纹",
  "block.minecraft.banner.bricks.lime": "黄绿色砖纹",
  "block.minecraft.banner.bricks.magenta": "品红色砖纹",
  "block.minecraft.banner.bricks.orange": "橙色砖纹",
  "block.minecraft.banner.bricks.pink": "粉红色砖纹",
  "block.minecraft.banner.bricks.purple": "紫色砖纹",
  "block.minecraft.banner.bricks.red": "红色砖纹",
  "block.minecraft.banner.bricks.white": "白色砖纹",
  "block.minecraft.banner.bricks.yellow": "黄色砖纹",
  "block.minecraft.banner.circle.black": "黑色圆形",
  "block.minecraft.banner.circle.blue": "蓝色圆形",
  "block.minecraft.banner.circle.brown": "棕色圆形",
  "block.minecraft.banner.circle.cyan": "青色圆形",
  "block.minecraft.banner.circle.gray": "灰色圆形",
  "block.minecraft.banner.circle.green": "绿色圆形",
  "block.minecraft.banner.circle.light_blue": "淡蓝色圆形",
  "block.minecraft.banner.circle.light_gray": "淡灰色圆形",
  "block.minecraft.banner.circle.lime": "黄绿色圆形",
  "block.minecraft.banner.circle.magenta": "品红色圆形",
  "block.minecraft.banner.circle.orange": "橙色圆形",
  "block.minecraft.banner.circle.pink": "粉红色圆形",
  "block.minecraft.banner.circle.purple": "紫色圆形",
  "block.minecraft.banner.circle.red": "红色圆形",
  "block.minecraft.banner.circle.white": "白色圆形",
  "block.minecraft.banner.circle.yellow": "黄色圆形",
  "block.minecraft.banner.creeper.black": "黑色苦力怕盾徽",
  "block.minecraft.banner.creeper.blue": "蓝色苦力怕盾徽",
  "block.minecraft.banner.creeper.brown": "棕色苦力怕盾徽",
  "block.minecraft.banner.creeper.cyan": "青色苦力怕盾徽",
  "block.minecraft.banner.creeper.gray": "灰色苦力怕盾徽",
  "block.minecraft.banner.creeper.green": "绿色苦力怕盾徽",
  "block.minecraft.banner.creeper.light_blue": "淡蓝色苦力怕盾徽",
  "block.minecraft.banner.creeper.light_gray": "淡灰色苦力怕盾徽",
  "block.minecraft.banner.creeper.lime": "黄绿色苦力怕盾徽",
  "block.minecraft.banner.creeper.magenta": "品红色苦力怕盾徽",
  "block.minecraft.banner.creeper.orange": "橙色苦力怕盾徽",
  "block.minecraft.banner.creeper.pink": "粉红色苦力怕盾徽",
  "block.minecraft.banner.creeper.purple": "紫色苦力怕盾徽",
  "block.minecraft.banner.creeper.red": "红色苦力怕盾徽",
  "block.minecraft.banner.creeper.white": "白色苦力怕盾徽",
  "block.minecraft.banner.creeper.yellow": "黄色苦力怕盾徽",
  "block.minecraft.banner.cross.black": "黑斜十字",
  "block.minecraft.banner.cross.blue": "蓝斜十字",
  "block.minecraft.banner.cross.brown": "棕斜十字",
  "block.minecraft.banner.cross.cyan": "青斜十字",
  "block.minecraft.banner.cross.gray": "灰斜十字",
  "block.minecraft.banner.cross.green": "绿斜十字",
  "block.minecraft.banner.cross.light_blue": "淡蓝斜十字",
  "block.minecraft.banner.cross.light_gray": "淡灰斜十字",
  "block.minecraft.banner.cross.lime": "黄绿斜十字",
  "block.minecraft.banner.cross.magenta": "品红斜十字",
  "block.minecraft.banner.cross.orange": "橙斜十字",
  "block.minecraft.banner.cross.pink": "粉红斜十字",
  "block.minecraft.banner.cross.purple": "紫斜十字",
  "block.minecraft.banner.cross.red": "红斜十字",
  "block.minecraft.banner.cross.white": "白斜十字",
  "block.minecraft.banner.cross.yellow": "黄斜十字",
  "block.minecraft.banner.curly_border.black": "黑色波纹边",
  "block.minecraft.banner.curly_border.blue": "蓝色波纹边",
  "block.minecraft.banner.curly_border.brown": "棕色波纹边",
  "block.minecraft.banner.curly_border.cyan": "青色波纹边",
  "block.minecraft.banner.curly_border.gray": "灰色波纹边",
  "block.minecraft.banner.curly_border.green": "绿色波纹边",
  "block.minecraft.banner.curly_border.light_blue": "淡蓝色波纹边",
  "block.minecraft.banner.curly_border.light_gray": "淡灰色波纹边",
  "block.minecraft.banner.curly_border.lime": "黄绿色波纹边",
  "block.minecraft.banner.curly_border.magenta": "品红色波纹边",
  "block.minecraft.banner.curly_border.orange": "橙色波纹边",
  "block.minecraft.banner.curly_border.pink": "粉红色波纹边",
  "block.minecraft.banner.curly_border.purple": "紫色波纹边",
  "block.minecraft.banner.curly_border.red": "红色波纹边",
  "block.minecraft.banner.curly_border.white": "白色波纹边",
  "block.minecraft.banner.curly_border.yellow": "黄色波纹边",
  "block.minecraft.banner.diagonal_left.black": "黑色右上三角",
  "block.minecraft.banner.diagonal_left.blue": "蓝色右上三角",
  "block.minecraft.banner.diagonal_left.brown": "棕色右上三角",
  "block.minecraft.banner.diagonal_left.cyan": "青色右上三角",
  "block.minecraft.banner.diagonal_left.gray": "灰色右上三角",
  "block.minecraft.banner.diagonal_left.green": "绿色右上三角",
  "block.minecraft.banner.diagonal_left.light_blue": "淡蓝色右上三角",
  "block.minecraft.banner.diagonal_left.light_gray": "淡灰色右上三角",
  "block.minecraft.banner.diagonal_left.lime": "黄绿色右上三角",
  "block.minecraft.banner.diagonal_left.magenta": "品红色右上三角",
  "block.minecraft.banner.diagonal_left.orange": "橙色右上三角",
  "block.minecraft.banner.diagonal_left.pink": "粉红色右上三角",
  "block.minecraft.banner.diagonal_left.purple": "紫色右上三角",
  "block.minecraft.banner.diagonal_left.red": "红色右上三角",
  "block.minecraft.banner.diagonal_left.white": "白色右上三角",
  "block.minecraft.banner.diagonal_left.yellow": "黄色右上三角",
  "block.minecraft.banner.diagonal_right.black": "黑色左上三角",
  "block.minecraft.banner.diagonal_right.blue": "蓝色左上三角",
  "block.minecraft.banner.diagonal_right.brown": "棕色左上三角",
  "block.minecraft.banner.diagonal_right.cyan": "青色左上三角",
  "block.minecraft.banner.diagonal_right.gray": "灰色左上三角",
  "block.minecraft.banner.diagonal_right.green": "绿色左上三角",
  "block.minecraft.banner.diagonal_right.light_blue": "淡蓝色左上三角",
  "block.minecraft.banner.diagonal_right.light_gray": "淡灰色左上三角",
  "block.minecraft.banner.diagonal_right.lime": "黄绿色左上三角",
  "block.minecraft.banner.diagonal_right.magenta": "品红色左上三角",
  "block.minecraft.banner.diagonal_right.orange": "橙色左上三角",
  "block.minecraft.banner.diagonal_right.pink": "粉红色左上三角",
  "block.minecraft.banner.diagonal_right.purple": "紫色左上三角",
  "block.minecraft.banner.diagonal_right.red": "红色左上三角",
  "block.minecraft.banner.diagonal_right.white": "白色左上三角",
  "block.minecraft.banner.diagonal_right.yellow": "黄色左上三角",
  "block.minecraft.banner.diagonal_up_left.black": "黑色右下三角",
  "block.minecraft.banner.diagonal_up_left.blue": "蓝色右下三角",
  "block.minecraft.banner.diagonal_up_left.brown": "棕色右下三角",
  "block.minecraft.banner.diagonal_up_left.cyan": "青色右下三角",
  "block.minecraft.banner.diagonal_up_left.gray": "灰色右下三角",
  "block.minecraft.banner.diagonal_up_left.green": "绿色右下三角",
  "block.minecraft.banner.diagonal_up_left.light_blue": "淡蓝色右下三角",
  "block.minecraft.banner.diagonal_up_left.light_gray": "淡灰色右下三角",
  "block.minecraft.banner.diagonal_up_left.lime": "黄绿色右下三角",
  "block.minecraft.banner.diagonal_up_left.magenta": "品红色右下三角",
  "block.minecraft.banner.diagonal_up_left.orange": "橙色右下三角",
  "block.minecraft.banner.diagonal_up_left.pink": "粉红色右下三角",
  "block.minecraft.banner.diagonal_up_left.purple": "紫色右下三角",
  "block.minecraft.banner.diagonal_up_left.red": "红色右下三角",
  "block.minecraft.banner.diagonal_up_left.white": "白色右下三角",
  "block.minecraft.banner.diagonal_up_left.yellow": "黄色右下三角",
  "block.minecraft.banner.diagonal_up_right.black": "黑色左下三角",
  "block.minecraft.banner.diagonal_up_right.blue": "蓝色左下三角",
  "block.minecraft.banner.diagonal_up_right.brown": "棕色左下三角",
  "block.minecraft.banner.diagonal_up_right.cyan": "青色左下三角",
  "block.minecraft.banner.diagonal_up_right.gray": "灰色左下三角",
  "block.minecraft.banner.diagonal_up_right.green": "绿色左下三角",
  "block.minecraft.banner.diagonal_up_right.light_blue": "淡蓝色左下三角",
  "block.minecraft.banner.diagonal_up_right.light_gray": "淡灰色左下三角",
  "block.minecraft.banner.diagonal_up_right.lime": "黄绿色左下三角",
  "block.minecraft.banner.diagonal_up_right.magenta": "品红色左下三角",
  "block.minecraft.banner.diagonal_up_right.orange": "橙色左下三角",
  "block.minecraft.banner.diagonal_up_right.pink": "粉红色左下三角",
  "block.minecraft.banner.diagonal_up_right.purple": "紫色左下三角",
  "block.minecraft.banner.diagonal_up_right.red": "红色左下三角",
  "block.minecraft.banner.diagonal_up_right.white": "白色左下三角",
  "block.minecraft.banner.diagonal_up_right.yellow": "黄色左下三角",
  "block.minecraft.banner.flow.black": "黑色涡流",
  "block.minecraft.banner.flow.blue": "蓝色涡流",
  "block.minecraft.banner.flow.brown": "棕色涡流",
  "block.minecraft.banner.flow.cyan": "青色涡流",
  "block.minecraft.banner.flow.gray": "灰色涡流",
  "block.minecraft.banner.flow.green": "绿色涡流",
  "block.minecraft.banner.flow.light_blue": "淡蓝色涡流",
  "block.minecraft.banner.flow.light_gray": "淡灰色涡流",
  "block.minecraft.banner.flow.lime": "黄绿色涡流",
  "block.minecraft.banner.flow.magenta": "品红色涡流",
  "block.minecraft.banner.flow.orange": "橙色涡流",
  "block.minecraft.banner.flow.pink": "粉红色涡流",
  "block.minecraft.banner.flow.purple": "紫色涡流",
  "block.minecraft.banner.flow.red": "红色涡流",
  "block.minecraft.banner.flow.white": "白色涡流",
  "block.minecraft.banner.flow.yellow": "黄色涡流",
  "block.minecraft.banner.flower.black": "黑色花朵盾徽",
  "block.minecraft.banner.flower.blue": "蓝色花朵盾徽",
  "block.minecraft.banner.flower.brown": "棕色花朵盾徽",
  "block.minecraft.banner.flower.cyan": "青色花朵盾徽",
  "block.minecraft.banner.flower.gray": "灰色花朵盾徽",
  "block.minecraft.banner.flower.green": "绿色花朵盾徽",
  "block.minecraft.banner.flower.light_blue": "淡蓝色花朵盾徽",
  "block.minecraft.banner.flower.light_gray": "淡灰色花朵盾徽",
  "block.minecraft.banner.flower.lime": "黄绿色花朵盾徽",
  "block.minecraft.banner.flower.magenta": "品红色花朵盾徽",
  "block.minecraft.banner.flower.orange": "橙色花朵盾徽",
  "block.minecraft.banner.flower.pink": "粉红色花朵盾徽",
  "block.minecraft.banner.flower.purple": "紫色花朵盾徽",
  "block.minecraft.banner.flower.red": "红色花朵盾徽",
  "block.minecraft.banner.flower.white": "白色花朵盾徽",
  "block.minecraft.banner.flower.yellow": "黄色花朵盾徽",
  "block.minecraft.banner.globe.black": "黑色地球",
  "block.minecraft.banner.globe.blue": "蓝色地球",
  "block.minecraft.banner.globe.brown": "棕色地球",
  "block.minecraft.banner.globe.cyan": "青色地球",
  "block.minecraft.banner.globe.gray": "灰色地球",
  "block.minecraft.banner.globe.green": "绿色地球",
  "block.minecraft.banner.globe.light_blue": "淡蓝色地球",
  "block.minecraft.banner.globe.light_gray": "淡灰色地球",
  "block.minecraft.banner.globe.lime": "黄绿色地球",
  "block.minecraft.banner.globe.magenta": "品红色地球",
  "block.minecraft.banner.globe.orange": "橙色地球",
  "block.minecraft.banner.globe.pink": "粉红色地球",
  "block.minecraft.banner.globe.purple": "紫色地球",
  "block.minecraft.banner.globe.red": "红色地球",
  "block.minecraft.banner.globe.white": "白色地球",
  "block.minecraft.banner.globe.yellow": "黄色地球",
  "block.minecraft.banner.gradient.black": "黑色自上渐淡",
  "block.minecraft.banner.gradient.blue": "蓝色自上渐淡",
  "block.minecraft.banner.gradient.brown": "棕色自上渐淡",
  "block.minecraft.banner.gradient.cyan": "青色自上渐淡",
  "block.minecraft.banner.gradient.gray": "灰色自上渐淡",
  "block.minecraft.banner.gradient.green": "绿色自上渐淡",
  "block.minecraft.banner.gradient.light_blue": "淡蓝色自上渐淡",
  "block.minecraft.banner.gradient.light_gray": "淡灰色自上渐淡",
  "block.minecraft.banner.gradient.lime": "黄绿色自上渐淡",
  "block.minecraft.banner.gradient.magenta": "品红色自上渐淡",
  "block.minecraft.banner.gradient.orange": "橙色自上渐淡",
  "block.minecraft.banner.gradient.pink": "粉红色自上渐淡",
  "block.minecraft.banner.gradient.purple": "紫色自上渐淡",
  "block.minecraft.banner.gradient.red": "红色自上渐淡",
  "block.minecraft.banner.gradient.white": "白色自上渐淡",
  "block.minecraft.banner.gradient.yellow": "黄色自上渐淡",
  "block.minecraft.banner.gradient_up.black": "黑色自下渐淡",
  "block.minecraft.banner.gradient_up.blue": "蓝色自下渐淡",
  "block.minecraft.banner.gradient_up.brown": "棕色自下渐淡",
  "block.minecraft.banner.gradient_up.cyan": "青色自下渐淡",
  "block.minecraft.banner.gradient_up.gray": "灰色自下渐淡",
  "block.minecraft.banner.gradient_up.green": "绿色自下渐淡",
  "block.minecraft.banner.gradient_up.light_blue": "淡蓝色自下渐淡",
  "block.minecraft.banner.gradient_up.light_gray": "淡灰色自下渐淡",
  "block.minecraft.banner.gradient_up.lime": "黄绿色自下渐淡",
  "block.minecraft.banner.gradient_up.magenta": "品红色自下渐淡",
  "block.minecraft.banner.gradient_up.orange": "橙色自下渐淡",
  "block.minecraft.banner.gradient_up.pink": "粉红色自下渐淡",
  "block.minecraft.banner.gradient_up.purple": "紫色自下渐淡",
  "block.minecraft.banner.gradient_up.red": "红色自下渐淡",
  "block.minecraft.banner.gradient_up.white": "白色自下渐淡",
  "block.minecraft.banner.gradient_up.yellow": "黄色自下渐淡",
  "block.minecraft.banner.guster.black": "黑色旋风",
  "block.minecraft.banner.guster.blue": "蓝色旋风",
  "block.minecraft.banner.guster.brown": "棕色旋风",
  "block.minecraft.banner.guster.cyan": "青色旋风",
  "block.minecraft.banner.guster.gray": "灰色旋风",
  "block.minecraft.banner.guster.green": "绿色旋风",
  "block.minecraft.banner.guster.light_blue": "淡蓝色旋风",
  "block.minecraft.banner.guster.light_gray": "淡灰色旋风",
  "block.minecraft.banner.guster.lime": "黄绿色旋风",
  "block.minecraft.banner.guster.magenta": "品红色旋风",
  "block.minecraft.banner.guster.orange": "橙色旋风",
  "block.minecraft.banner.guster.pink": "粉红色旋风",
  "block.minecraft.banner.guster.purple": "紫色旋风",
  "block.minecraft.banner.guster.red": "红色旋风",
  "block.minecraft.banner.guster.white": "白色旋风",
  "block.minecraft.banner.guster.yellow": "黄色旋风",
  "block.minecraft.banner.half_horizontal.black": "黑色上半方形",
  "block.minecraft.banner.half_horizontal.blue": "蓝色上半方形",
  "block.minecraft.banner.half_horizontal.brown": "棕色上半方形",
  "block.minecraft.banner.half_horizontal.cyan": "青色上半方形",
  "block.minecraft.banner.half_horizontal.gray": "灰色上半方形",
  "block.minecraft.banner.half_horizontal.green": "绿色上半方形",
  "block.minecraft.banner.half_horizontal.light_blue": "淡蓝色上半方形",
  "block.minecraft.banner.half_horizontal.light_gray": "淡灰色上半方形",
  "block.minecraft.banner.half_horizontal.lime": "黄绿色上半方形",
  "block.minecraft.banner.half_horizontal.magenta": "品红色上半方形",
  "block.minecraft.banner.half_horizontal.orange": "橙色上半方形",
  "block.minecraft.banner.half_horizontal.pink": "粉红色上半方形",
  "block.minecraft.banner.half_horizontal.purple": "紫色上半方形",
  "block.minecraft.banner.half_horizontal.red": "红色上半方形",
  "block.minecraft.banner.half_horizontal.white": "白色上半方形",
  "block.minecraft.banner.half_horizontal.yellow": "黄色上半方形",
  "block.minecraft.banner.half_horizontal_bottom.black": "黑色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.blue": "蓝色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.brown": "棕色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "青色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.gray": "灰色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.green": "绿色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "淡蓝色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "淡灰色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.lime": "黄绿色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "品红色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.orange": "橙色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.pink": "粉红色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.purple": "紫色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.red": "红色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.white": "白色下半方形",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "黄色下半方形",
  "block.minecraft.banner.half_vertical.black": "黑色右半方形",
  "block.minecraft.banner.half_vertical.blue": "蓝色右半方形",
  "block.minecraft.banner.half_vertical.brown": "棕色右半方形",
  "block.minecraft.banner.half_vertical.cyan": "青色右半方形",
  "block.minecraft.banner.half_vertical.gray": "灰色右半方形",
  "block.minecraft.banner.half_vertical.green": "绿色右半方形",
  "block.minecraft.banner.half_vertical.light_blue": "淡蓝色右半方形",
  "block.minecraft.banner.half_vertical.light_gray": "淡灰色右半方形",
  "block.minecraft.banner.half_vertical.lime": "黄绿色右半方形",
  "block.minecraft.banner.half_vertical.magenta": "品红色右半方形",
  "block.minecraft.banner.half_vertical.orange": "橙色右半方形",
  "block.minecraft.banner.half_vertical.pink": "粉红色右半方形",
  "block.minecraft.banner.half_vertical.purple": "紫色右半方形",
  "block.minecraft.banner.half_vertical.red": "红色右半方形",
  "block.minecraft.banner.half_vertical.white": "白色右半方形",
  "block.minecraft.banner.half_vertical.yellow": "黄色右半方形",
  "block.minecraft.banner.half_vertical_right.black": "黑色左半方形",
  "block.minecraft.banner.half_vertical_right.blue": "蓝色左半方形",
  "block.minecraft.banner.half_vertical_right.brown": "棕色左半方形",
  "block.minecraft.banner.half_vertical_right.cyan": "青色左半方形",
  "block.minecraft.banner.half_vertical_right.gray": "灰色左半方形",
  "block.minecraft.banner.half_vertical_right.green": "绿色左半方形",
  "block.minecraft.banner.half_vertical_right.light_blue": "淡蓝色左半方形",
  "block.minecraft.banner.half_vertical_right.light_gray": "淡灰色左半方形",
  "block.minecraft.banner.half_vertical_right.lime": "黄绿色左半方形",
  "block.minecraft.banner.half_vertical_right.magenta": "品红色左半方形",
  "block.minecraft.banner.half_vertical_right.orange": "橙色左半方形",
  "block.minecraft.banner.half_vertical_right.pink": "粉红色左半方形",
  "block.minecraft.banner.half_vertical_right.purple": "紫色左半方形",
  "block.minecraft.banner.half_vertical_right.red": "红色左半方形",
  "block.minecraft.banner.half_vertical_right.white": "白色左半方形",
  "block.minecraft.banner.half_vertical_right.yellow": "黄色左半方形",
  "block.minecraft.banner.mojang.black": "黑色Mojang徽标",
  "block.minecraft.banner.mojang.blue": "蓝色Mojang徽标",
  "block.minecraft.banner.mojang.brown": "棕色Mojang徽标",
  "block.minecraft.banner.mojang.cyan": "青色Mojang徽标",
  "block.minecraft.banner.mojang.gray": "灰色Mojang徽标",
  "block.minecraft.banner.mojang.green": "绿色Mojang徽标",
  "block.minecraft.banner.mojang.light_blue": "淡蓝色Mojang徽标",
  "block.minecraft.banner.mojang.light_gray": "淡灰色Mojang徽标",
  "block.minecraft.banner.mojang.lime": "黄绿色Mojang徽标",
  "block.minecraft.banner.mojang.magenta": "品红色Mojang徽标",
  "block.minecraft.banner.mojang.orange": "橙色Mojang徽标",
  "block.minecraft.banner.mojang.pink": "粉红色Mojang徽标",
  "block.minecraft.banner.mojang.purple": "紫色Mojang徽标",
  "block.minecraft.banner.mojang.red": "红色Mojang徽标",
  "block.minecraft.banner.mojang.white": "白色Mojang徽标",
  "block.minecraft.banner.mojang.yellow": "黄色Mojang徽标",
  "block.minecraft.banner.piglin.black": "黑色猪鼻",
  "block.minecraft.banner.piglin.blue": "蓝色猪鼻",
  "block.minecraft.banner.piglin.brown": "棕色猪鼻",
  "block.minecraft.banner.piglin.cyan": "青色猪鼻",
  "block.minecraft.banner.piglin.gray": "灰色猪鼻",
  "block.minecraft.banner.piglin.green": "绿色猪鼻",
  "block.minecraft.banner.piglin.light_blue": "淡蓝色猪鼻",
  "block.minecraft.banner.piglin.light_gray": "淡灰色猪鼻",
  "block.minecraft.banner.piglin.lime": "黄绿色猪鼻",
  "block.minecraft.banner.piglin.magenta": "品红色猪鼻",
  "block.minecraft.banner.piglin.orange": "橙色猪鼻",
  "block.minecraft.banner.piglin.pink": "粉红色猪鼻",
  "block.minecraft.banner.piglin.purple": "紫色猪鼻",
  "block.minecraft.banner.piglin.red": "红色猪鼻",
  "block.minecraft.banner.piglin.white": "白色猪鼻",
  "block.minecraft.banner.piglin.yellow": "黄色猪鼻",
  "block.minecraft.banner.rhombus.black": "黑色菱形",
  "block.minecraft.banner.rhombus.blue": "蓝色菱形",
  "block.minecraft.banner.rhombus.brown": "棕色菱形",
  "block.minecraft.banner.rhombus.cyan": "青色菱形",
  "block.minecraft.banner.rhombus.gray": "灰色菱形",
  "block.minecraft.banner.rhombus.green": "绿色菱形",
  "block.minecraft.banner.rhombus.light_blue": "淡蓝色菱形",
  "block.minecraft.banner.rhombus.light_gray": "淡灰色菱形",
  "block.minecraft.banner.rhombus.lime": "黄绿色菱形",
  "block.minecraft.banner.rhombus.magenta": "品红色菱形",
  "block.minecraft.banner.rhombus.orange": "橙色菱形",
  "block.minecraft.banner.rhombus.pink": "粉红色菱形",
  "block.minecraft.banner.rhombus.purple": "紫色菱形",
  "block.minecraft.banner.rhombus.red": "红色菱形",
  "block.minecraft.banner.rhombus.white": "白色菱形",
  "block.minecraft.banner.rhombus.yellow": "黄色菱形",
  "block.minecraft.banner.skull.black": "黑色头颅盾徽",
  "block.minecraft.banner.skull.blue": "蓝色头颅盾徽",
  "block.minecraft.banner.skull.brown": "棕色头颅盾徽",
  "block.minecraft.banner.skull.cyan": "青色头颅盾徽",
  "block.minecraft.banner.skull.gray": "灰色头颅盾徽",
  "block.minecraft.banner.skull.green": "绿色头颅盾徽",
  "block.minecraft.banner.skull.light_blue": "淡蓝色头颅盾徽",
  "block.minecraft.banner.skull.light_gray": "淡灰色头颅盾徽",
  "block.minecraft.banner.skull.lime": "黄绿色头颅盾徽",
  "block.minecraft.banner.skull.magenta": "品红色头颅盾徽",
  "block.minecraft.banner.skull.orange": "橙色头颅盾徽",
  "block.minecraft.banner.skull.pink": "粉红色头颅盾徽",
  "block.minecraft.banner.skull.purple": "紫色头颅盾徽",
  "block.minecraft.banner.skull.red": "红色头颅盾徽",
  "block.minecraft.banner.skull.white": "白色头颅盾徽",
  "block.minecraft.banner.skull.yellow": "黄色头颅盾徽",
  "block.minecraft.banner.small_stripes.black": "黑竖条纹",
  "block.minecraft.banner.small_stripes.blue": "蓝竖条纹",
  "block.minecraft.banner.small_stripes.brown": "棕竖条纹",
  "block.minecraft.banner.small_stripes.cyan": "青竖条纹",
  "block.minecraft.banner.small_stripes.gray": "灰竖条纹",
  "block.minecraft.banner.small_stripes.green": "绿竖条纹",
  "block.minecraft.banner.small_stripes.light_blue": "淡蓝竖条纹",
  "block.minecraft.banner.small_stripes.light_gray": "淡灰竖条纹",
  "block.minecraft.banner.small_stripes.lime": "黄绿竖条纹",
  "block.minecraft.banner.small_stripes.magenta": "品红竖条纹",
  "block.minecraft.banner.small_stripes.orange": "橙竖条纹",
  "block.minecraft.banner.small_stripes.pink": "粉红竖条纹",
  "block.minecraft.banner.small_stripes.purple": "紫竖条纹",
  "block.minecraft.banner.small_stripes.red": "红竖条纹",
  "block.minecraft.banner.small_stripes.white": "白竖条纹",
  "block.minecraft.banner.small_stripes.yellow": "黄竖条纹",
  "block.minecraft.banner.square_bottom_left.black": "右底黑方",
  "block.minecraft.banner.square_bottom_left.blue": "右底蓝方",
  "block.minecraft.banner.square_bottom_left.brown": "右底棕方",
  "block.minecraft.banner.square_bottom_left.cyan": "右底青方",
  "block.minecraft.banner.square_bottom_left.gray": "右底灰方",
  "block.minecraft.banner.square_bottom_left.green": "右底绿方",
  "block.minecraft.banner.square_bottom_left.light_blue": "右底淡蓝方",
  "block.minecraft.banner.square_bottom_left.light_gray": "右底淡灰方",
  "block.minecraft.banner.square_bottom_left.lime": "右底黄绿方",
  "block.minecraft.banner.square_bottom_left.magenta": "右底品红方",
  "block.minecraft.banner.square_bottom_left.orange": "右底橙方",
  "block.minecraft.banner.square_bottom_left.pink": "右底粉红方",
  "block.minecraft.banner.square_bottom_left.purple": "右底紫方",
  "block.minecraft.banner.square_bottom_left.red": "右底红方",
  "block.minecraft.banner.square_bottom_left.white": "右底白方",
  "block.minecraft.banner.square_bottom_left.yellow": "右底黄方",
  "block.minecraft.banner.square_bottom_right.black": "左底黑方",
  "block.minecraft.banner.square_bottom_right.blue": "左底蓝方",
  "block.minecraft.banner.square_bottom_right.brown": "左底棕方",
  "block.minecraft.banner.square_bottom_right.cyan": "左底青方",
  "block.minecraft.banner.square_bottom_right.gray": "左底灰方",
  "block.minecraft.banner.square_bottom_right.green": "左底绿方",
  "block.minecraft.banner.square_bottom_right.light_blue": "左底淡蓝方",
  "block.minecraft.banner.square_bottom_right.light_gray": "左底淡灰方",
  "block.minecraft.banner.square_bottom_right.lime": "左底黄绿方",
  "block.minecraft.banner.square_bottom_right.magenta": "左底品红方",
  "block.minecraft.banner.square_bottom_right.orange": "左底橙方",
  "block.minecraft.banner.square_bottom_right.pink": "左底粉红方",
  "block.minecraft.banner.square_bottom_right.purple": "左底紫方",
  "block.minecraft.banner.square_bottom_right.red": "左底红方",
  "block.minecraft.banner.square_bottom_right.white": "左底白方",
  "block.minecraft.banner.square_bottom_right.yellow": "左底黄方",
  "block.minecraft.banner.square_top_left.black": "右顶黑方",
  "block.minecraft.banner.square_top_left.blue": "右顶蓝方",
  "block.minecraft.banner.square_top_left.brown": "右顶棕方",
  "block.minecraft.banner.square_top_left.cyan": "右顶青方",
  "block.minecraft.banner.square_top_left.gray": "右顶灰方",
  "block.minecraft.banner.square_top_left.green": "右顶绿方",
  "block.minecraft.banner.square_top_left.light_blue": "右顶淡蓝方",
  "block.minecraft.banner.square_top_left.light_gray": "右顶淡灰方",
  "block.minecraft.banner.square_top_left.lime": "右顶黄绿方",
  "block.minecraft.banner.square_top_left.magenta": "右顶品红方",
  "block.minecraft.banner.square_top_left.orange": "右顶橙方",
  "block.minecraft.banner.square_top_left.pink": "右顶粉红方",
  "block.minecraft.banner.square_top_left.purple": "右顶紫方",
  "block.minecraft.banner.square_top_left.red": "右顶红方",
  "block.minecraft.banner.square_top_left.white": "右顶白方",
  "block.minecraft.banner.square_top_left.yellow": "右顶黄方",
  "block.minecraft.banner.square_top_right.black": "左顶黑方",
  "block.minecraft.banner.square_top_right.blue": "左顶蓝方",
  "block.minecraft.banner.square_top_right.brown": "左顶棕方",
  "block.minecraft.banner.square_top_right.cyan": "左顶青方",
  "block.minecraft.banner.square_top_right.gray": "左顶灰方",
  "block.minecraft.banner.square_top_right.green": "左顶绿方",
  "block.minecraft.banner.square_top_right.light_blue": "左顶淡蓝方",
  "block.minecraft.banner.square_top_right.light_gray": "左顶淡灰方",
  "block.minecraft.banner.square_top_right.lime": "左顶黄绿方",
  "block.minecraft.banner.square_top_right.magenta": "左顶品红方",
  "block.minecraft.banner.square_top_right.orange": "左顶橙方",
  "block.minecraft.banner.square_top_right.pink": "左顶粉红方",
  "block.minecraft.banner.square_top_right.purple": "左顶紫方",
  "block.minecraft.banner.square_top_right.red": "左顶红方",
  "block.minecraft.banner.square_top_right.white": "左顶白方",
  "block.minecraft.banner.square_top_right.yellow": "左顶黄方",
  "block.minecraft.banner.straight_cross.black": "黑正十字",
  "block.minecraft.banner.straight_cross.blue": "蓝正十字",
  "block.minecraft.banner.straight_cross.brown": "棕正十字",
  "block.minecraft.banner.straight_cross.cyan": "青正十字",
  "block.minecraft.banner.straight_cross.gray": "灰正十字",
  "block.minecraft.banner.straight_cross.green": "绿正十字",
  "block.minecraft.banner.straight_cross.light_blue": "淡蓝正十字",
  "block.minecraft.banner.straight_cross.light_gray": "淡灰正十字",
  "block.minecraft.banner.straight_cross.lime": "黄绿正十字",
  "block.minecraft.banner.straight_cross.magenta": "品红正十字",
  "block.minecraft.banner.straight_cross.orange": "橙正十字",
  "block.minecraft.banner.straight_cross.pink": "粉红正十字",
  "block.minecraft.banner.straight_cross.purple": "紫正十字",
  "block.minecraft.banner.straight_cross.red": "红正十字",
  "block.minecraft.banner.straight_cross.white": "白正十字",
  "block.minecraft.banner.straight_cross.yellow": "黄正十字",
  "block.minecraft.banner.stripe_bottom.black": "底黑横条",
  "block.minecraft.banner.stripe_bottom.blue": "底蓝横条",
  "block.minecraft.banner.stripe_bottom.brown": "底棕横条",
  "block.minecraft.banner.stripe_bottom.cyan": "底青横条",
  "block.minecraft.banner.stripe_bottom.gray": "底灰横条",
  "block.minecraft.banner.stripe_bottom.green": "底绿横条",
  "block.minecraft.banner.stripe_bottom.light_blue": "底淡蓝横条",
  "block.minecraft.banner.stripe_bottom.light_gray": "底淡灰横条",
  "block.minecraft.banner.stripe_bottom.lime": "底黄绿横条",
  "block.minecraft.banner.stripe_bottom.magenta": "底品红横条",
  "block.minecraft.banner.stripe_bottom.orange": "底橙横条",
  "block.minecraft.banner.stripe_bottom.pink": "底粉红横条",
  "block.minecraft.banner.stripe_bottom.purple": "底紫横条",
  "block.minecraft.banner.stripe_bottom.red": "底红横条",
  "block.minecraft.banner.stripe_bottom.white": "底白横条",
  "block.minecraft.banner.stripe_bottom.yellow": "底黄横条",
  "block.minecraft.banner.stripe_center.black": "中黑竖条",
  "block.minecraft.banner.stripe_center.blue": "中蓝竖条",
  "block.minecraft.banner.stripe_center.brown": "中棕竖条",
  "block.minecraft.banner.stripe_center.cyan": "中青竖条",
  "block.minecraft.banner.stripe_center.gray": "中灰竖条",
  "block.minecraft.banner.stripe_center.green": "中绿竖条",
  "block.minecraft.banner.stripe_center.light_blue": "中淡蓝竖条",
  "block.minecraft.banner.stripe_center.light_gray": "中淡灰竖条",
  "block.minecraft.banner.stripe_center.lime": "中黄绿竖条",
  "block.minecraft.banner.stripe_center.magenta": "中品红竖条",
  "block.minecraft.banner.stripe_center.orange": "中橙竖条",
  "block.minecraft.banner.stripe_center.pink": "中粉红竖条",
  "block.minecraft.banner.stripe_center.purple": "中紫竖条",
  "block.minecraft.banner.stripe_center.red": "中红竖条",
  "block.minecraft.banner.stripe_center.white": "中白竖条",
  "block.minecraft.banner.stripe_center.yellow": "中黄竖条",
  "block.minecraft.banner.stripe_downleft.black": "左黑斜条",
  "block.minecraft.banner.stripe_downleft.blue": "左蓝斜条",
  "block.minecraft.banner.stripe_downleft.brown": "左棕斜条",
  "block.minecraft.banner.stripe_downleft.cyan": "左青斜条",
  "block.minecraft.banner.stripe_downleft.gray": "左灰斜条",
  "block.minecraft.banner.stripe_downleft.green": "左绿斜条",
  "block.minecraft.banner.stripe_downleft.light_blue": "左淡蓝斜条",
  "block.minecraft.banner.stripe_downleft.light_gray": "左淡灰斜条",
  "block.minecraft.banner.stripe_downleft.lime": "左黄绿斜条",
  "block.minecraft.banner.stripe_downleft.magenta": "左品红斜条",
  "block.minecraft.banner.stripe_downleft.orange": "左橙斜条",
  "block.minecraft.banner.stripe_downleft.pink": "左粉红斜条",
  "block.minecraft.banner.stripe_downleft.purple": "左紫斜条",
  "block.minecraft.banner.stripe_downleft.red": "左红斜条",
  "block.minecraft.banner.stripe_downleft.white": "左白斜条",
  "block.minecraft.banner.stripe_downleft.yellow": "左黄斜条",
  "block.minecraft.banner.stripe_downright.black": "右黑斜条",
  "block.minecraft.banner.stripe_downright.blue": "右蓝斜条",
  "block.minecraft.banner.stripe_downright.brown": "右棕斜条",
  "block.minecraft.banner.stripe_downright.cyan": "右青斜条",
  "block.minecraft.banner.stripe_downright.gray": "右灰斜条",
  "block.minecraft.banner.stripe_downright.green": "右绿斜条",
  "block.minecraft.banner.stripe_downright.light_blue": "右淡蓝斜条",
  "block.minecraft.banner.stripe_downright.light_gray": "右淡灰斜条",
  "block.minecraft.banner.stripe_downright.lime": "右黄绿斜条",
  "block.minecraft.banner.stripe_downright.magenta": "右品红斜条",
  "block.minecraft.banner.stripe_downright.orange": "右橙斜条",
  "block.minecraft.banner.stripe_downright.pink": "右粉红斜条",
  "block.minecraft.banner.stripe_downright.purple": "右紫斜条",
  "block.minecraft.banner.stripe_downright.red": "右红斜条",
  "block.minecraft.banner.stripe_downright.white": "右白斜条",
  "block.minecraft.banner.stripe_downright.yellow": "右黄斜条",
  "block.minecraft.banner.stripe_left.black": "右黑竖条",
  "block.minecraft.banner.stripe_left.blue": "右蓝竖条",
  "block.minecraft.banner.stripe_left.brown": "右棕竖条",
  "block.minecraft.banner.stripe_left.cyan": "右青竖条",
  "block.minecraft.banner.stripe_left.gray": "右灰竖条",
  "block.minecraft.banner.stripe_left.green": "右绿竖条",
  "block.minecraft.banner.stripe_left.light_blue": "右淡蓝竖条",
  "block.minecraft.banner.stripe_left.light_gray": "右淡灰竖条",
  "block.minecraft.banner.stripe_left.lime": "右黄绿竖条",
  "block.minecraft.banner.stripe_left.magenta": "右品红竖条",
  "block.minecraft.banner.stripe_left.orange": "右橙竖条",
  "block.minecraft.banner.stripe_left.pink": "右粉红竖条",
  "block.minecraft.banner.stripe_left.purple": "右紫竖条",
  "block.minecraft.banner.stripe_left.red": "右红竖条",
  "block.minecraft.banner.stripe_left.white": "右白竖条",
  "block.minecraft.banner.stripe_left.yellow": "右黄竖条",
  "block.minecraft.banner.stripe_middle.black": "中黑横条",
  "block.minecraft.banner.stripe_middle.blue": "中蓝横条",
  "block.minecraft.banner.stripe_middle.brown": "中棕横条",
  "block.minecraft.banner.stripe_middle.cyan": "中青横条",
  "block.minecraft.banner.stripe_middle.gray": "中灰横条",
  "block.minecraft.banner.stripe_middle.green": "中绿横条",
  "block.minecraft.banner.stripe_middle.light_blue": "中淡蓝横条",
  "block.minecraft.banner.stripe_middle.light_gray": "中淡灰横条",
  "block.minecraft.banner.stripe_middle.lime": "中黄绿横条",
  "block.minecraft.banner.stripe_middle.magenta": "中品红横条",
  "block.minecraft.banner.stripe_middle.orange": "中橙横条",
  "block.minecraft.banner.stripe_middle.pink": "中粉红横条",
  "block.minecraft.banner.stripe_middle.purple": "中紫横条",
  "block.minecraft.banner.stripe_middle.red": "中红横条",
  "block.minecraft.banner.stripe_middle.white": "中白横条",
  "block.minecraft.banner.stripe_middle.yellow": "中黄横条",
  "block.minecraft.banner.stripe_right.black": "左黑竖条",
  "block.minecraft.banner.stripe_right.blue": "左蓝竖条",
  "block.minecraft.banner.stripe_right.brown": "左棕竖条",
  "block.minecraft.banner.stripe_right.cyan": "左青竖条",
  "block.minecraft.banner.stripe_right.gray": "左灰竖条",
  "block.minecraft.banner.stripe_right.green": "左绿竖条",
  "block.minecraft.banner.stripe_right.light_blue": "左淡蓝竖条",
  "block.minecraft.banner.stripe_right.light_gray": "左淡灰竖条",
  "block.minecraft.banner.stripe_right.lime": "左黄绿竖条",
  "block.minecraft.banner.stripe_right.magenta": "左品红竖条",
  "block.minecraft.banner.stripe_right.orange": "左橙竖条",
  "block.minecraft.banner.stripe_right.pink": "左粉红竖条",
  "block.minecraft.banner.stripe_right.purple": "左紫竖条",
  "block.minecraft.banner.stripe_right.red": "左红竖条",
  "block.minecraft.banner.stripe_right.white": "左白竖条",
  "block.minecraft.banner.stripe_right.yellow": "左黄竖条",
  "block.minecraft.banner.stripe_top.black": "顶黑横条",
  "block.minecraft.banner.stripe_top.blue": "顶蓝横条",
  "block.minecraft.banner.stripe_top.brown": "顶棕横条",
  "block.minecraft.banner.stripe_top.cyan": "顶青横条",
  "block.minecraft.banner.stripe_top.gray": "顶灰横条",
  "block.minecraft.banner.stripe_top.green": "顶绿横条",
  "block.minecraft.banner.stripe_top.light_blue": "顶淡蓝横条",
  "block.minecraft.banner.stripe_top.light_gray": "顶淡灰横条",
  "block.minecraft.banner.stripe_top.lime": "顶黄绿横条",
  "block.minecraft.banner.stripe_top.magenta": "顶品红横条",
  "block.minecraft.banner.stripe_top.orange": "顶橙横条",
  "block.minecraft.banner.stripe_top.pink": "顶粉红横条",
  "block.minecraft.banner.stripe_top.purple": "顶紫横条",
  "block.minecraft.banner.stripe_top.red": "顶红横条",
  "block.minecraft.banner.stripe_top.white": "顶白横条",
  "block.minecraft.banner.stripe_top.yellow": "顶黄横条",
  "block.minecraft.banner.triangle_bottom.black": "底黑三角",
  "block.minecraft.banner.triangle_bottom.blue": "底蓝三角",
  "block.minecraft.banner.triangle_bottom.brown": "底棕三角",
  "block.minecraft.banner.triangle_bottom.cyan": "底青三角",
  "block.minecraft.banner.triangle_bottom.gray": "底灰三角",
  "block.minecraft.banner.triangle_bottom.green": "底绿三角",
  "block.minecraft.banner.triangle_bottom.light_blue": "底淡蓝三角",
  "block.minecraft.banner.triangle_bottom.light_gray": "底淡灰三角",
  "block.minecraft.banner.triangle_bottom.lime": "底黄绿三角",
  "block.minecraft.banner.triangle_bottom.magenta": "底品红三角",
  "block.minecraft.banner.triangle_bottom.orange": "底橙三角",
  "block.minecraft.banner.triangle_bottom.pink": "底粉红三角",
  "block.minecraft.banner.triangle_bottom.purple": "底紫三角",
  "block.minecraft.banner.triangle_bottom.red": "底红三角",
  "block.minecraft.banner.triangle_bottom.white": "底白三角",
  "block.minecraft.banner.triangle_bottom.yellow": "底黄三角",
  "block.minecraft.banner.triangle_top.black": "顶黑三角",
  "block.minecraft.banner.triangle_top.blue": "顶蓝三角",
  "block.minecraft.banner.triangle_top.brown": "顶棕三角",
  "block.minecraft.banner.triangle_top.cyan": "顶青三角",
  "block.minecraft.banner.triangle_top.gray": "顶灰三角",
  "block.minecraft.banner.triangle_top.green": "顶绿三角",
  "block.minecraft.banner.triangle_top.light_blue": "顶淡蓝三角",
  "block.minecraft.banner.triangle_top.light_gray": "顶淡灰三角",
  "block.minecraft.banner.triangle_top.lime": "顶黄绿三角",
  "block.minecraft.banner.triangle_top.magenta": "顶品红三角",
  "block.minecraft.banner.triangle_top.orange": "顶橙三角",
  "block.minecraft.banner.triangle_top.pink": "顶粉红三角",
  "block.minecraft.banner.triangle_top.purple": "顶紫三角",
  "block.minecraft.banner.triangle_top.red": "顶红三角",
  "block.minecraft.banner.triangle_top.white": "顶白三角",
  "block.minecraft.banner.triangle_top.yellow": "顶黄三角",
  "block.minecraft.banner.triangles_bottom.black": "黑色底波纹",
  "block.minecraft.banner.triangles_bottom.blue": "蓝色底波纹",
  "block.minecraft.banner.triangles_bottom.brown": "棕色底波纹",
  "block.minecraft.banner.triangles_bottom.cyan": "青色底波纹",
  "block.minecraft.banner.triangles_bottom.gray": "灰色底波纹",
  "block.minecraft.banner.triangles_bottom.green": "绿色底波纹",
  "block.minecraft.banner.triangles_bottom.light_blue": "淡蓝色底波纹",
  "block.minecraft.banner.triangles_bottom.light_gray": "淡灰色底波纹",
  "block.minecraft.banner.triangles_bottom.lime": "黄绿色底波纹",
  "block.minecraft.banner.triangles_bottom.magenta": "品红色底波纹",
  "block.minecraft.banner.triangles_bottom.orange": "橙色底波纹",
  "block.minecraft.banner.triangles_bottom.pink": "粉红色底波纹",
  "block.minecraft.banner.triangles_bottom.purple": "紫色底波纹",
  "block.minecraft.banner.triangles_bottom.red": "红色底波纹",
  "block.minecraft.banner.triangles_bottom.white": "白色底波纹",
  "block.minecraft.banner.triangles_bottom.yellow": "黄色底波纹",
  "block.minecraft.banner.triangles_top.black": "黑色顶波纹",
  "block.minecraft.banner.triangles_top.blue": "蓝色顶波纹",
  "block.minecraft.banner.triangles_top.brown": "棕色顶波纹",
  "block.minecraft.banner.triangles_top.cyan": "青色顶波纹",
  "block.minecraft.banner.triangles_top.gray": "灰色顶波纹",
  "block.minecraft.banner.triangles_top.green": "绿色顶波纹",
  "block.minecraft.banner.triangles_top.light_blue": "淡蓝色顶波纹",
  "block.minecraft.banner.triangles_top.light_gray": "淡灰色顶波纹",
  "block.minecraft.banner.triangles_top.lime": "黄绿色顶波纹",
  "block.minecraft.banner.triangles_top.magenta": "品红色顶波纹",
  "block.minecraft.banner.triangles_top.orange": "橙色顶波纹",
  "block.minecraft.banner.triangles_top.pink": "粉红色顶波纹",
  "block.minecraft.banner.triangles_top.purple": "紫色顶波纹",
  "block.minecraft.banner.triangles_top.red": "红色顶波纹",
  "block.minecraft.banner.triangles_top.white": "白色顶波纹",
  "block.minecraft.banner.triangles_top.yellow": "黄色顶波纹",
  "block.minecraft.barrel": "木桶",
  "block.minecraft.barrier": "屏障",
  "block.minecraft.basalt": "玄武岩",
  "block.minecraft.beacon": "信标",
  "block.minecraft.beacon.primary": "主效果",
  "block.minecraft.beacon.secondary": "辅助效果",
  "block.minecraft.bed.no_sleep": "你只能在夜间或雷暴中入眠",
  "block.minecraft.bed.not_safe": "你现在不能休息，周围有怪物在游荡",
  "block.minecraft.bed.obstructed": "这张床已被阻挡",
  "block.minecraft.bed.occupied": "这张床已被占用",
  "block.minecraft.bed.too_far_away": "你现在不能休息，床太远了",
  "block.minecraft.bedrock": "基岩",
  "block.minecraft.bee_nest": "蜂巢",
  "block.minecraft.beehive": "蜂箱",
  "block.minecraft.beetroots": "甜菜根",
  "block.minecraft.bell": "钟",
  "block.minecraft.big_dripleaf": "大型垂滴叶",
  "block.minecraft.big_dripleaf_stem": "大型垂滴叶茎",
  "block.minecraft.birch_button": "白桦木按钮",
  "block.minecraft.birch_door": "白桦木门",
  "block.minecraft.birch_fence": "白桦木栅栏",
  "block.minecraft.birch_fence_gate": "白桦木栅栏门",
  "block.minecraft.birch_hanging_sign": "悬挂式白桦木告示牌",
  "block.minecraft.birch_leaves": "白桦树叶",
  "block.minecraft.birch_log": "白桦原木",
  "block.minecraft.birch_planks": "白桦木板",
  "block.minecraft.birch_pressure_plate": "白桦木压力板",
  "block.minecraft.birch_sapling": "白桦树苗",
  "block.minecraft.birch_shelf": "白桦木展示架",
  "block.minecraft.birch_sign": "白桦木告示牌",
  "block.minecraft.birch_slab": "白桦木台阶",
  "block.minecraft.birch_stairs": "白桦木楼梯",
  "block.minecraft.birch_trapdoor": "白桦木活板门",
  "block.minecraft.birch_wall_hanging_sign": "墙上的悬挂式白桦木告示牌",
  "block.minecraft.birch_wall_sign": "墙上的白桦木告示牌",
  "block.minecraft.birch_wood": "白桦木",
  "block.minecraft.black_banner": "黑色旗帜",
  "block.minecraft.black_bed": "黑色床",
  "block.minecraft.black_candle": "黑色蜡烛",
  "block.minecraft.black_candle_cake": "插上黑色蜡烛的蛋糕",
  "block.minecraft.black_carpet": "黑色地毯",
  "block.minecraft.black_concrete": "黑色混凝土",
  "block.minecraft.black_concrete_powder": "黑色混凝土粉末",
  "block.minecraft.black_glazed_terracotta": "黑色带釉陶瓦",
  "block.minecraft.black_shulker_box": "黑色潜影盒",
  "block.minecraft.black_stained_glass": "黑色染色玻璃",
  "block.minecraft.black_stained_glass_pane": "黑色染色玻璃板",
  "block.minecraft.black_terracotta": "黑色陶瓦",
  "block.minecraft.black_wool": "黑色羊毛",
  "block.minecraft.blackstone": "黑石",
  "block.minecraft.blackstone_slab": "黑石台阶",
  "block.minecraft.blackstone_stairs": "黑石楼梯",
  "block.minecraft.blackstone_wall": "黑石墙",
  "block.minecraft.blast_furnace": "高炉",
  "block.minecraft.blue_banner": "蓝色旗帜",
  "block.minecraft.blue_bed": "蓝色床",
  "block.minecraft.blue_candle": "蓝色蜡烛",
  "block.minecraft.blue_candle_cake": "插上蓝色蜡烛的蛋糕",
  "block.minecraft.blue_carpet": "蓝色地毯",
  "block.minecraft.blue_concrete": "蓝色混凝土",
  "block.minecraft.blue_concrete_powder": "蓝色混凝土粉末",
  "block.minecraft.blue_glazed_terracotta": "蓝色带釉陶瓦",
  "block.minecraft.blue_ice": "蓝冰",
  "block.minecraft.blue_orchid": "兰花",
  "block.minecraft.blue_shulker_box": "蓝色潜影盒",
  "block.minecraft.blue_stained_glass": "蓝色染色玻璃",
  "block.minecraft.blue_stained_glass_pane": "蓝色染色玻璃板",
  "block.minecraft.blue_terracotta": "蓝色陶瓦",
  "block.minecraft.blue_wool": "蓝色羊毛",
  "block.minecraft.bone_block": "骨块",
  "block.minecraft.bookshelf": "书架",
  "block.minecraft.brain_coral": "脑纹珊瑚",
  "block.minecraft.brain_coral_block": "脑纹珊瑚块",
  "block.minecraft.brain_coral_fan": "脑纹珊瑚扇",
  "block.minecraft.brain_coral_wall_fan": "墙上的脑纹珊瑚扇",
  "block.minecraft.brewing_stand": "酿造台",
  "block.minecraft.brick_slab": "红砖台阶",
  "block.minecraft.brick_stairs": "红砖楼梯",
  "block.minecraft.brick_wall": "红砖墙",
  "block.minecraft.bricks": "红砖块",
  "block.minecraft.brown_banner": "棕色旗帜",
  "block.minecraft.brown_bed": "棕色床",
  "block.minecraft.brown_candle": "棕色蜡烛",
  "block.minecraft.brown_candle_cake": "插上棕色蜡烛的蛋糕",
  "block.minecraft.brown_carpet": "棕色地毯",
  "block.minecraft.brown_concrete": "棕色混凝土",
  "block.minecraft.brown_concrete_powder": "棕色混凝土粉末",
  "block.minecraft.brown_glazed_terracotta": "棕色带釉陶瓦",
  "block.minecraft.brown_mushroom": "棕色蘑菇",
  "block.minecraft.brown_mushroom_block": "棕色蘑菇方块",
  "block.minecraft.brown_shulker_box": "棕色潜影盒",
  "block.minecraft.brown_stained_glass": "棕色染色玻璃",
  "block.minecraft.brown_stained_glass_pane": "棕色染色玻璃板",
  "block.minecraft.brown_terracotta": "棕色陶瓦",
  "block.minecraft.brown_wool": "棕色羊毛",
  "block.minecraft.bubble_column": "气泡柱",
  "block.minecraft.bubble_coral": "气泡珊瑚",
  "block.minecraft.bubble_coral_block": "气泡珊瑚块",
  "block.minecraft.bubble_coral_fan": "气泡珊瑚扇",
  "block.minecraft.bubble_coral_wall_fan": "墙上的气泡珊瑚扇",
  "block.minecraft.budding_amethyst": "紫水晶母岩",
  "block.minecraft.bush": "灌木丛",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.cactus_flower": "仙人掌花",
  "block.minecraft.cake": "蛋糕",
  "block.minecraft.calcite": "方解石",
  "block.minecraft.calibrated_sculk_sensor": "校频幽匿感测体",
  "block.minecraft.campfire": "营火",
  "block.minecraft.candle": "蜡烛",
  "block.minecraft.candle_cake": "插上蜡烛的蛋糕",
  "block.minecraft.carrots": "胡萝卜",
  "block.minecraft.cartography_table": "制图台",
  "block.minecraft.carved_pumpkin": "雕刻南瓜",
  "block.minecraft.cauldron": "炼药锅",
  "block.minecraft.cave_air": "洞穴空气",
  "block.minecraft.cave_vines": "洞穴藤蔓",
  "block.minecraft.cave_vines_plant": "洞穴藤蔓植株",
  "block.minecraft.chain": "锁链",
  "block.minecraft.chain_command_block": "连锁型命令方块",
  "block.minecraft.cherry_button": "樱花木按钮",
  "block.minecraft.cherry_door": "樱花木门",
  "block.minecraft.cherry_fence": "樱花木栅栏",
  "block.minecraft.cherry_fence_gate": "樱花木栅栏门",
  "block.minecraft.cherry_hanging_sign": "悬挂式樱花木告示牌",
  "block.minecraft.cherry_leaves": "樱花树叶",
  "block.minecraft.cherry_log": "樱花原木",
  "block.minecraft.cherry_planks": "樱花木板",
  "block.minecraft.cherry_pressure_plate": "樱花木压力板",
  "block.minecraft.cherry_sapling": "樱花树苗",
  "block.minecraft.cherry_shelf": "樱花木展示架",
  "block.minecraft.cherry_sign": "樱花木告示牌",
  "block.minecraft.cherry_slab": "樱花木台阶",
  "block.minecraft.cherry_stairs": "樱花木楼梯",
  "block.minecraft.cherry_trapdoor": "樱花木活板门",
  "block.minecraft.cherry_wall_hanging_sign": "墙上的悬挂式樱花木告示牌",
  "block.minecraft.cherry_wall_sign": "墙上的樱花木告示牌",
  "block.minecraft.cherry_wood": "樱花木",
  "block.minecraft.chest": "箱子",
  "block.minecraft.chipped_anvil": "开裂的铁砧",
  "block.minecraft.chiseled_bookshelf": "雕纹书架",
  "block.minecraft.chiseled_copper": "雕纹铜块",
  "block.minecraft.chiseled_deepslate": "雕纹深板岩",
  "block.minecraft.chiseled_nether_bricks": "雕纹下界砖块",
  "block.minecraft.chiseled_polished_blackstone": "雕纹磨制黑石",
  "block.minecraft.chiseled_quartz_block": "雕纹石英块",
  "block.minecraft.chiseled_red_sandstone": "雕纹红砂岩",
  "block.minecraft.chiseled_resin_bricks": "雕纹树脂砖块",
  "block.minecraft.chiseled_sandstone": "雕纹砂岩",
  "block.minecraft.chiseled_stone_bricks": "雕纹石砖",
  "block.minecraft.chiseled_tuff": "雕纹凝灰岩",
  "block.minecraft.chiseled_tuff_bricks": "雕纹凝灰岩砖",
  "block.minecraft.chorus_flower": "紫颂花",
  "block.minecraft.chorus_plant": "紫颂植株",
  "block.minecraft.clay": "黏土",
  "block.minecraft.closed_eyeblossom": "闭合的眼眸花",
  "block.minecraft.coal_block": "煤炭块",
  "block.minecraft.coal_ore": "煤矿石",
  "block.minecraft.coarse_dirt": "砂土",
  "block.minecraft.cobbled_deepslate": "深板岩圆石",
  "block.minecraft.cobbled_deepslate_slab": "深板岩圆石台阶",
  "block.minecraft.cobbled_deepslate_stairs": "深板岩圆石楼梯",
  "block.minecraft.cobbled_deepslate_wall": "深板岩圆石墙",
  "block.minecraft.cobblestone": "圆石",
  "block.minecraft.cobblestone_slab": "圆石台阶",
  "block.minecraft.cobblestone_stairs": "圆石楼梯",
  "block.minecraft.cobblestone_wall": "圆石墙",
  "block.minecraft.cobweb": "蜘蛛网",
  "block.minecraft.cocoa": "可可果",
  "block.minecraft.command_block": "命令方块",
  "block.minecraft.comparator": "红石比较器",
  "block.minecraft.composter": "堆肥桶",
  "block.minecraft.conduit": "潮涌核心",
  "block.minecraft.copper_bars": "铜栏杆",
  "block.minecraft.copper_block": "铜块",
  "block.minecraft.copper_bulb": "铜灯",
  "block.minecraft.copper_chain": "铜链",
  "block.minecraft.copper_chest": "铜箱子",
  "block.minecraft.copper_door": "铜门",
  "block.minecraft.copper_golem_statue": "铜傀儡像",
  "block.minecraft.copper_grate": "铜格栅",
  "block.minecraft.copper_lantern": "铜灯笼",
  "block.minecraft.copper_ore": "铜矿石",
  "block.minecraft.copper_torch": "铜火把",
  "block.minecraft.copper_trapdoor": "铜活板门",
  "block.minecraft.copper_wall_torch": "墙上的铜火把",
  "block.minecraft.cornflower": "矢车菊",
  "block.minecraft.cracked_deepslate_bricks": "裂纹深板岩砖",
  "block.minecraft.cracked_deepslate_tiles": "裂纹深板岩瓦",
  "block.minecraft.cracked_nether_bricks": "裂纹下界砖块",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂纹磨制黑石砖",
  "block.minecraft.cracked_stone_bricks": "裂纹石砖",
  "block.minecraft.crafter": "合成器",
  "block.minecraft.crafting_table": "工作台",
  "block.minecraft.creaking_heart": "嘎枝之心",
  "block.minecraft.creeper_head": "苦力怕的头",
  "block.minecraft.creeper_wall_head": "墙上的苦力怕的头",
  "block.minecraft.crimson_button": "绯红木按钮",
  "block.minecraft.crimson_door": "绯红木门",
  "block.minecraft.crimson_fence": "绯红木栅栏",
  "block.minecraft.crimson_fence_gate": "绯红木栅栏门",
  "block.minecraft.crimson_fungus": "绯红菌",
  "block.minecraft.crimson_hanging_sign": "悬挂式绯红木告示牌",
  "block.minecraft.crimson_hyphae": "绯红菌核",
  "block.minecraft.crimson_nylium": "绯红菌岩",
  "block.minecraft.crimson_planks": "绯红木板",
  "block.minecraft.crimson_pressure_plate": "绯红木压力板",
  "block.minecraft.crimson_roots": "绯红菌索",
  "block.minecraft.crimson_shelf": "绯红木展示架",
  "block.minecraft.crimson_sign": "绯红木告示牌",
  "block.minecraft.crimson_slab": "绯红木台阶",
  "block.minecraft.crimson_stairs": "绯红木楼梯",
  "block.minecraft.crimson_stem": "绯红菌柄",
  "block.minecraft.crimson_trapdoor": "绯红木活板门",
  "block.minecraft.crimson_wall_hanging_sign": "墙上的悬挂式绯红木告示牌",
  "block.minecraft.crimson_wall_sign": "墙上的绯红木告示牌",
  "block.minecraft.crying_obsidian": "哭泣的黑曜石",
  "block.minecraft.cut_copper": "切制铜块",
  "block.minecraft.cut_copper_slab": "切制铜台阶",
  "block.minecraft.cut_copper_stairs": "切制铜楼梯",
  "block.minecraft.cut_red_sandstone": "切制红砂岩",
  "block.minecraft.cut_red_sandstone_slab": "切制红砂岩台阶",
  "block.minecraft.cut_sandstone": "切制砂岩",
  "block.minecraft.cut_sandstone_slab": "切制砂岩台阶",
  "block.minecraft.cyan_banner": "青色旗帜",
  "block.minecraft.cyan_bed": "青色床",
  "block.minecraft.cyan_candle": "青色蜡烛",
  "block.minecraft.cyan_candle_cake": "插上青色蜡烛的蛋糕",
  "block.minecraft.cyan_carpet": "青色地毯",
  "block.minecraft.cyan_concrete": "青色混凝土",
  "block.minecraft.cyan_concrete_powder": "青色混凝土粉末",
  "block.minecraft.cyan_glazed_terracotta": "青色带釉陶瓦",
  "block.minecraft.cyan_shulker_box": "青色潜影盒",
  "block.minecraft.cyan_stained_glass": "青色染色玻璃",
  "block.minecraft.cyan_stained_glass_pane": "青色染色玻璃板",
  "block.minecraft.cyan_terracotta": "青色陶瓦",
  "block.minecraft.cyan_wool": "青色羊毛",
  "block.minecraft.damaged_anvil": "损坏的铁砧",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.dark_oak_button": "深色橡木按钮",
  "block.minecraft.dark_oak_door": "深色橡木门",
  "block.minecraft.dark_oak_fence": "深色橡木栅栏",
  "block.minecraft.dark_oak_fence_gate": "深色橡木栅栏门",
  "block.minecraft.dark_oak_hanging_sign": "悬挂式深色橡木告示牌",
  "block.minecraft.dark_oak_leaves": "深色橡树树叶",
  "block.minecraft.dark_oak_log": "深色橡木原木",
  "block.minecraft.dark_oak_planks": "深色橡木木板",
  "block.minecraft.dark_oak_pressure_plate": "深色橡木压力板",
  "block.minecraft.dark_oak_sapling": "深色橡树树苗",
  "block.minecraft.dark_oak_shelf": "深色橡木展示架",
  "block.minecraft.dark_oak_sign": "深色橡木告示牌",
  "block.minecraft.dark_oak_slab": "深色橡木台阶",
  "block.minecraft.dark_oak_stairs": "深色橡木楼梯",
  "block.minecraft.dark_oak_trapdoor": "深色橡木活板门",
  "block.minecraft.dark_oak_wall_hanging_sign": "墙上的悬挂式深色橡木告示牌",
  "block.minecraft.dark_oak_wall_sign": "墙上的深色橡木告示牌",
  "block.minecraft.dark_oak_wood": "深色橡木",
  "block.minecraft.dark_prismarine": "暗海晶石",
  "block.minecraft.dark_prismarine_slab": "暗海晶石台阶",
  "block.minecraft.dark_prismarine_stairs": "暗海晶石楼梯",
  "block.minecraft.daylight_detector": "阳光探测器",
  "block.minecraft.dead_brain_coral": "失活的脑纹珊瑚",
  "block.minecraft.dead_brain_coral_block": "失活的脑纹珊瑚块",
  "block.minecraft.dead_brain_coral_fan": "失活的脑纹珊瑚扇",
  "block.minecraft.dead_brain_coral_wall_fan": "墙上的失活脑纹珊瑚扇",
  "block.minecraft.dead_bubble_coral": "失活的气泡珊瑚",
  "block.minecraft.dead_bubble_coral_block": "失活的气泡珊瑚块",
  "block.minecraft.dead_bubble_coral_fan": "失活的气泡珊瑚扇",
  "block.minecraft.dead_bubble_coral_wall_fan": "墙上的失活气泡珊瑚扇",
  "block.minecraft.dead_bush": "枯萎的灌木",
  "block.minecraft.dead_fire_coral": "失活的火珊瑚",
  "block.minecraft.dead_fire_coral_block": "失活的火珊瑚块",
  "block.minecraft.dead_fire_coral_fan": "失活的火珊瑚扇",
  "block.minecraft.dead_fire_coral_wall_fan": "墙上的失活火珊瑚扇",
  "block.minecraft.dead_horn_coral": "失活的鹿角珊瑚",
  "block.minecraft.dead_horn_coral_block": "失活的鹿角珊瑚块",
  "block.minecraft.dead_horn_coral_fan": "失活的鹿角珊瑚扇",
  "block.minecraft.dead_horn_coral_wall_fan": "墙上的失活鹿角珊瑚扇",
  "block.minecraft.dead_tube_coral": "失活的管珊瑚",
  "block.minecraft.dead_tube_coral_block": "失活的管珊瑚块",
  "block.minecraft.dead_tube_coral_fan": "失活的管珊瑚扇",
  "block.minecraft.dead_tube_coral_wall_fan": "墙上的失活管珊瑚扇",
  "block.minecraft.decorated_pot": "饰纹陶罐",
  "block.minecraft.deepslate": "深板岩",
  "block.minecraft.deepslate_brick_slab": "深板岩砖台阶",
  "block.minecraft.deepslate_brick_stairs": "深板岩砖楼梯",
  "block.minecraft.deepslate_brick_wall": "深板岩砖墙",
  "block.minecraft.deepslate_bricks": "深板岩砖",
  "block.minecraft.deepslate_coal_ore": "深层煤矿石",
  "block.minecraft.deepslate_copper_ore": "深层铜矿石",
  "block.minecraft.deepslate_diamond_ore": "深层钻石矿石",
  "block.minecraft.deepslate_emerald_ore": "深层绿宝石矿石",
  "block.minecraft.deepslate_gold_ore": "深层金矿石",
  "block.minecraft.deepslate_iron_ore": "深层铁矿石",
  "block.minecraft.deepslate_lapis_ore": "深层青金石矿石",
  "block.minecraft.deepslate_redstone_ore": "深层红石矿石",
  "block.minecraft.deepslate_tile_slab": "深板岩瓦台阶",
  "block.minecraft.deepslate_tile_stairs": "深板岩瓦楼梯",
  "block.minecraft.deepslate_tile_wall": "深板岩瓦墙",
  "block.minecraft.deepslate_tiles": "深板岩瓦",
  "block.minecraft.detector_rail": "探测铁轨",
  "block.minecraft.diamond_block": "钻石块",
  "block.minecraft.diamond_ore": "钻石矿石",
  "block.minecraft.diorite": "闪长岩",
  "block.minecraft.diorite_slab": "闪长岩台阶",
  "block.minecraft.diorite_stairs": "闪长岩楼梯",
  "block.minecraft.diorite_wall": "闪长岩墙",
  "block.minecraft.dirt": "泥土",
  "block.minecraft.dirt_path": "土径",
  "block.minecraft.dispenser": "发射器",
  "block.minecraft.dragon_egg": "龙蛋",
  "block.minecraft.dragon_head": "龙首",
  "block.minecraft.dragon_wall_head": "墙上的龙首",
  "block.minecraft.dried_ghast": "失水恶魂",
  "block.minecraft.dried_kelp_block": "干海带块",
  "block.minecraft.dripstone_block": "滴水石块",
  "block.minecraft.dropper": "投掷器",
  "block.minecraft.emerald_block": "绿宝石块",
  "block.minecraft.emerald_ore": "绿宝石矿石",
  "block.minecraft.enchanting_table": "附魔台",
  "block.minecraft.end_gateway": "末地折跃门",
  "block.minecraft.end_portal": "末地传送门",
  "block.minecraft.end_portal_frame": "末地传送门框架",
  "block.minecraft.end_rod": "末地烛",
  "block.minecraft.end_stone": "末地石",
  "block.minecraft.end_stone_brick_slab": "末地石砖台阶",
  "block.minecraft.end_stone_brick_stairs": "末地石砖楼梯",
  "block.minecraft.end_stone_brick_wall": "末地石砖墙",
  "block.minecraft.end_stone_bricks": "末地石砖",
  "block.minecraft.ender_chest": "末影箱",
  "block.minecraft.exposed_chiseled_copper": "斑驳的雕纹铜块",
  "block.minecraft.exposed_copper": "斑驳的铜块",
  "block.minecraft.exposed_copper_bars": "斑驳的铜栏杆",
  "block.minecraft.exposed_copper_bulb": "斑驳的铜灯",
  "block.minecraft.exposed_copper_chain": "斑驳的铜链",
  "block.minecraft.exposed_copper_chest": "斑驳的铜箱子",
  "block.minecraft.exposed_copper_door": "斑驳的铜门",
  "block.minecraft.exposed_copper_golem_statue": "斑驳的铜傀儡像",
  "block.minecraft.exposed_copper_grate": "斑驳的铜格栅",
  "block.minecraft.exposed_copper_lantern": "斑驳的铜灯笼",
  "block.minecraft.exposed_copper_trapdoor": "斑驳的铜活板门",
  "block.minecraft.exposed_cut_copper": "斑驳的切制铜块",
  "block.minecraft.exposed_cut_copper_slab": "斑驳的切制铜台阶",
  "block.minecraft.exposed_cut_copper_stairs": "斑驳的切制铜楼梯",
  "block.minecraft.exposed_lightning_rod": "斑驳的避雷针",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.fern": "蕨",
  "block.minecraft.fire": "火",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.fire_coral_block": "火珊瑚块",
  "block.minecraft.fire_coral_fan": "火珊瑚扇",
  "block.minecraft.fire_coral_wall_fan": "墙上的火珊瑚扇",
  "block.minecraft.firefly_bush": "萤火虫灌木丛",
  "block.minecraft.fletching_table": "制箭台",
  "block.minecraft.flower_pot": "花盆",
  "block.minecraft.flowering_azalea": "盛开的杜鹃花丛",
  "block.minecraft.flowering_azalea_leaves": "盛开的杜鹃树叶",
  "block.minecraft.frogspawn": "青蛙卵",
  "block.minecraft.frosted_ice": "霜冰",
  "block.minecraft.furnace": "熔炉",
  "block.minecraft.gilded_blackstone": "镶金黑石",
  "block.minecraft.glass": "玻璃",
  "block.minecraft.glass_pane": "玻璃板",
  "block.minecraft.glow_lichen": "发光地衣",
  "block.minecraft.glowstone": "荧石",
  "block.minecraft.gold_block": "金块",
  "block.minecraft.gold_ore": "金矿石",
  "block.minecraft.golden_dandelion": "金蒲公英",
  "block.minecraft.granite": "花岗岩",
  "block.minecraft.granite_slab": "花岗岩台阶",
  "block.minecraft.granite_stairs": "花岗岩楼梯",
  "block.minecraft.granite_wall": "花岗岩墙",
  "block.minecraft.grass": "草",
  "block.minecraft.grass_block": "草方块",
  "block.minecraft.gravel": "沙砾",
  "block.minecraft.gray_banner": "灰色旗帜",
  "block.minecraft.gray_bed": "灰色床",
  "block.minecraft.gray_candle": "灰色蜡烛",
  "block.minecraft.gray_candle_cake": "插上灰色蜡烛的蛋糕",
  "block.minecraft.gray_carpet": "灰色地毯",
  "block.minecraft.gray_concrete": "灰色混凝土",
  "block.minecraft.gray_concrete_powder": "灰色混凝土粉末",
  "block.minecraft.gray_glazed_terracotta": "灰色带釉陶瓦",
  "block.minecraft.gray_shulker_box": "灰色潜影盒",
  "block.minecraft.gray_stained_glass": "灰色染色玻璃",
  "block.minecraft.gray_stained_glass_pane": "灰色染色玻璃板",
  "block.minecraft.gray_terracotta": "灰色陶瓦",
  "block.minecraft.gray_wool": "灰色羊毛",
  "block.minecraft.green_banner": "绿色旗帜",
  "block.minecraft.green_bed": "绿色床",
  "block.minecraft.green_candle": "绿色蜡烛",
  "block.minecraft.green_candle_cake": "插上绿色蜡烛的蛋糕",
  "block.minecraft.green_carpet": "绿色地毯",
  "block.minecraft.green_concrete": "绿色混凝土",
  "block.minecraft.green_concrete_powder": "绿色混凝土粉末",
  "block.minecraft.green_glazed_terracotta": "绿色带釉陶瓦",
  "block.minecraft.green_shulker_box": "绿色潜影盒",
  "block.minecraft.green_stained_glass": "绿色染色玻璃",
  "block.minecraft.green_stained_glass_pane": "绿色染色玻璃板",
  "block.minecraft.green_terracotta": "绿色陶瓦",
  "block.minecraft.green_wool": "绿色羊毛",
  "block.minecraft.grindstone": "砂轮",
  "block.minecraft.hanging_roots": "垂根",
  "block.minecraft.hay_block": "干草捆",
  "block.minecraft.heavy_core": "沉重核心",
  "block.minecraft.heavy_weighted_pressure_plate": "重质测重压力板",
  "block.minecraft.honey_block": "蜂蜜块",
  "block.minecraft.honeycomb_block": "蜜脾块",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.horn_coral": "鹿角珊瑚",
  "block.minecraft.horn_coral_block": "鹿角珊瑚块",
  "block.minecraft.horn_coral_fan": "鹿角珊瑚扇",
  "block.minecraft.horn_coral_wall_fan": "墙上的鹿角珊瑚扇",
  "block.minecraft.ice": "冰",
  "block.minecraft.infested_chiseled_stone_bricks": "虫蚀雕纹石砖",
  "block.minecraft.infested_cobblestone": "虫蚀圆石",
  "block.minecraft.infested_cracked_stone_bricks": "虫蚀裂纹石砖",
  "block.minecraft.infested_deepslate": "虫蚀深板岩",
  "block.minecraft.infested_mossy_stone_bricks": "虫蚀苔石砖",
  "block.minecraft.infested_stone": "虫蚀石头",
  "block.minecraft.infested_stone_bricks": "虫蚀石砖",
  "block.minecraft.iron_bars": "铁栏杆",
  "block.minecraft.iron_block": "铁块",
  "block.minecraft.iron_chain": "铁链",
  "block.minecraft.iron_door": "铁门",
  "block.minecraft.iron_ore": "铁矿石",
  "block.minecraft.iron_trapdoor": "铁活板门",
  "block.minecraft.jack_o_lantern": "南瓜灯",
  "block.minecraft.jigsaw": "拼图方块",
  "block.minecraft.jukebox": "唱片机",
  "block.minecraft.jungle_button": "丛林木按钮",
  "block.minecraft.jungle_door": "丛林木门",
  "block.minecraft.jungle_fence": "丛林木栅栏",
  "block.minecraft.jungle_fence_gate": "丛林木栅栏门",
  "block.minecraft.jungle_hanging_sign": "悬挂式丛林木告示牌",
  "block.minecraft.jungle_leaves": "丛林树叶",
  "block.minecraft.jungle_log": "丛林原木",
  "block.minecraft.jungle_planks": "丛林木板",
  "block.minecraft.jungle_pressure_plate": "丛林木压力板",
  "block.minecraft.jungle_sapling": "丛林树苗",
  "block.minecraft.jungle_shelf": "丛林木展示架",
  "block.minecraft.jungle_sign": "丛林木告示牌",
  "block.minecraft.jungle_slab": "丛林木台阶",
  "block.minecraft.jungle_stairs": "丛林木楼梯",
  "block.minecraft.jungle_trapdoor": "丛林木活板门",
  "block.minecraft.jungle_wall_hanging_sign": "墙上的悬挂式丛林木告示牌",
  "block.minecraft.jungle_wall_sign": "墙上的丛林木告示牌",
  "block.minecraft.jungle_wood": "丛林木",
  "block.minecraft.kelp": "海带",
  "block.minecraft.kelp_plant": "海带植株",
  "block.minecraft.ladder": "梯子",
  "block.minecraft.lantern": "灯笼",
  "block.minecraft.lapis_block": "青金石块",
  "block.minecraft.lapis_ore": "青金石矿石",
  "block.minecraft.large_amethyst_bud": "大型紫晶芽",
  "block.minecraft.large_fern": "大型蕨",
  "block.minecraft.lava": "熔岩",
  "block.minecraft.lava_cauldron": "装有熔岩的炼药锅",
  "block.minecraft.leaf_litter": "枯叶堆",
  "block.minecraft.lectern": "讲台",
  "block.minecraft.lever": "拉杆",
  "block.minecraft.light": "光源方块",
  "block.minecraft.light_blue_banner": "淡蓝色旗帜",
  "block.minecraft.light_blue_bed": "淡蓝色床",
  "block.minecraft.light_blue_candle": "淡蓝色蜡烛",
  "block.minecraft.light_blue_candle_cake": "插上淡蓝色蜡烛的蛋糕",
  "block.minecraft.light_blue_carpet": "淡蓝色地毯",
  "block.minecraft.light_blue_concrete": "淡蓝色混凝土",
  "block.minecraft.light_blue_concrete_powder": "淡蓝色混凝土粉末",
  "block.minecraft.light_blue_glazed_terracotta": "淡蓝色带釉陶瓦",
  "block.minecraft.light_blue_shulker_box": "淡蓝色潜影盒",
  "block.minecraft.light_blue_stained_glass": "淡蓝色染色玻璃",
  "block.minecraft.light_blue_stained_glass_pane": "淡蓝色染色玻璃板",
  "block.minecraft.light_blue_terracotta": "淡蓝色陶瓦",
  "block.minecraft.light_blue_wool": "淡蓝色羊毛",
  "block.minecraft.light_gray_banner": "淡灰色旗帜",
  "block.minecraft.light_gray_bed": "淡灰色床",
  "block.minecraft.light_gray_candle": "淡灰色蜡烛",
  "block.minecraft.light_gray_candle_cake": "插上淡灰色蜡烛的蛋糕",
  "block.minecraft.light_gray_carpet": "淡灰色地毯",
  "block.minecraft.light_gray_concrete": "淡灰色混凝土",
  "block.minecraft.light_gray_concrete_powder": "淡灰色混凝土粉末",
  "block.minecraft.light_gray_glazed_terracotta": "淡灰色带釉陶瓦",
  "block.minecraft.light_gray_shulker_box": "淡灰色潜影盒",
  "block.minecraft.light_gray_stained_glass": "淡灰色染色玻璃",
  "block.minecraft.light_gray_stained_glass_pane": "淡灰色染色玻璃板",
  "block.minecraft.light_gray_terracotta": "淡灰色陶瓦",
  "block.minecraft.light_gray_wool": "淡灰色羊毛",
  "block.minecraft.light_weighted_pressure_plate": "轻质测重压力板",
  "block.minecraft.lightning_rod": "避雷针",
  "block.minecraft.lilac": "丁香",
  "block.minecraft.lily_of_the_valley": "铃兰",
  "block.minecraft.lily_pad": "睡莲",
  "block.minecraft.lime_banner": "黄绿色旗帜",
  "block.minecraft.lime_bed": "黄绿色床",
  "block.minecraft.lime_candle": "黄绿色蜡烛",
  "block.minecraft.lime_candle_cake": "插上黄绿色蜡烛的蛋糕",
  "block.minecraft.lime_carpet": "黄绿色地毯",
  "block.minecraft.lime_concrete": "黄绿色混凝土",
  "block.minecraft.lime_concrete_powder": "黄绿色混凝土粉末",
  "block.minecraft.lime_glazed_terracotta": "黄绿色带釉陶瓦",
  "block.minecraft.lime_shulker_box": "黄绿色潜影盒",
  "block.minecraft.lime_stained_glass": "黄绿色染色玻璃",
  "block.minecraft.lime_stained_glass_pane": "黄绿色染色玻璃板",
  "block.minecraft.lime_terracotta": "黄绿色陶瓦",
  "block.minecraft.lime_wool": "黄绿色羊毛",
  "block.minecraft.lodestone": "磁石",
  "block.minecraft.loom": "织布机",
  "block.minecraft.magenta_banner": "品红色旗帜",
  "block.minecraft.magenta_bed": "品红色床",
  "block.minecraft.magenta_candle": "品红色蜡烛",
  "block.minecraft.magenta_candle_cake": "插上品红色蜡烛的蛋糕",
  "block.minecraft.magenta_carpet": "品红色地毯",
  "block.minecraft.magenta_concrete": "品红色混凝土",
  "block.minecraft.magenta_concrete_powder": "品红色混凝土粉末",
  "block.minecraft.magenta_glazed_terracotta": "品红色带釉陶瓦",
  "block.minecraft.magenta_shulker_box": "品红色潜影盒",
  "block.minecraft.magenta_stained_glass": "品红色染色玻璃",
  "block.minecraft.magenta_stained_glass_pane": "品红色染色玻璃板",
  "block.minecraft.magenta_terracotta": "品红色陶瓦",
  "block.minecraft.magenta_wool": "品红色羊毛",
  "block.minecraft.magma_block": "岩浆块",
  "block.minecraft.mangrove_button": "红树木按钮",
  "block.minecraft.mangrove_door": "红树木门",
  "block.minecraft.mangrove_fence": "红树木栅栏",
  "block.minecraft.mangrove_fence_gate": "红树木栅栏门",
  "block.minecraft.mangrove_hanging_sign": "悬挂式红树木告示牌",
  "block.minecraft.mangrove_leaves": "红树树叶",
  "block.minecraft.mangrove_log": "红树原木",
  "block.minecraft.mangrove_planks": "红树木板",
  "block.minecraft.mangrove_pressure_plate": "红树木压力板",
  "block.minecraft.mangrove_propagule": "红树胎生苗",
  "block.minecraft.mangrove_roots": "红树根",
  "block.minecraft.mangrove_shelf": "红树木展示架",
  "block.minecraft.mangrove_sign": "红树木告示牌",
  "block.minecraft.mangrove_slab": "红树木台阶",
  "block.minecraft.mangrove_stairs": "红树木楼梯",
  "block.minecraft.mangrove_trapdoor": "红树木活板门",
  "block.minecraft.mangrove_wall_hanging_sign": "墙上的悬挂式红树木告示牌",
  "block.minecraft.mangrove_wall_sign": "墙上的红树木告示牌",
  "block.minecraft.mangrove_wood": "红树木",
  "block.minecraft.medium_amethyst_bud": "中型紫晶芽",
  "block.minecraft.melon": "西瓜",
  "block.minecraft.melon_stem": "西瓜茎",
  "block.minecraft.moss_block": "苔藓块",
  "block.minecraft.moss_carpet": "覆地苔藓",
  "block.minecraft.mossy_cobblestone": "苔石",
  "block.minecraft.mossy_cobblestone_slab": "苔石台阶",
  "block.minecraft.mossy_cobblestone_stairs": "苔石楼梯",
  "block.minecraft.mossy_cobblestone_wall": "苔石墙",
  "block.minecraft.mossy_stone_brick_slab": "苔石砖台阶",
  "block.minecraft.mossy_stone_brick_stairs": "苔石砖楼梯",
  "block.minecraft.mossy_stone_brick_wall": "苔石砖墙",
  "block.minecraft.mossy_stone_bricks": "苔石砖",
  "block.minecraft.moving_piston": "移动的活塞",
  "block.minecraft.mud": "泥巴",
  "block.minecraft.mud_brick_slab": "泥砖台阶",
  "block.minecraft.mud_brick_stairs": "泥砖楼梯",
  "block.minecraft.mud_brick_wall": "泥砖墙",
  "block.minecraft.mud_bricks": "泥砖",
  "block.minecraft.muddy_mangrove_roots": "沾泥的红树根",
  "block.minecraft.mushroom_stem": "蘑菇柄",
  "block.minecraft.mycelium": "菌丝体",
  "block.minecraft.nether_brick_fence": "下界砖栅栏",
  "block.minecraft.nether_brick_slab": "下界砖台阶",
  "block.minecraft.nether_brick_stairs": "下界砖楼梯",
  "block.minecraft.nether_brick_wall": "下界砖墙",
  "block.minecraft.nether_bricks": "下界砖块",
  "block.minecraft.nether_gold_ore": "下界金矿石",
  "block.minecraft.nether_portal": "下界传送门",
  "block.minecraft.nether_quartz_ore": "下界石英矿石",
  "block.minecraft.nether_sprouts": "下界苗",
  "block.minecraft.nether_wart": "下界疣",
  "block.minecraft.nether_wart_block": "下界疣块",
  "block.minecraft.netherite_block": "下界合金块",
  "block.minecraft.netherrack": "下界岩",
  "block.minecraft.note_block": "音符盒",
  "block.minecraft.oak_button": "橡木按钮",
  "block.minecraft.oak_door": "橡木门",
  "block.minecraft.oak_fence": "橡木栅栏",
  "block.minecraft.oak_fence_gate": "橡木栅栏门",
  "block.minecraft.oak_hanging_sign": "悬挂式橡木告示牌",
  "block.minecraft.oak_leaves": "橡树树叶",
  "block.minecraft.oak_log": "橡木原木",
  "block.minecraft.oak_planks": "橡木木板",
  "block.minecraft.oak_pressure_plate": "橡木压力板",
  "block.minecraft.oak_sapling": "橡树树苗",
  "block.minecraft.oak_shelf": "橡木展示架",
  "block.minecraft.oak_sign": "橡木告示牌",
  "block.minecraft.oak_slab": "橡木台阶",
  "block.minecraft.oak_stairs": "橡木楼梯",
  "block.minecraft.oak_trapdoor": "橡木活板门",
  "block.minecraft.oak_wall_hanging_sign": "墙上的悬挂式橡木告示牌",
  "block.minecraft.oak_wall_sign": "墙上的橡木告示牌",
  "block.minecraft.oak_wood": "橡木",
  "block.minecraft.observer": "侦测器",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.ochre_froglight": "赭黄蛙明灯",
  "block.minecraft.ominous_banner": "不祥旗帜",
  "block.minecraft.open_eyeblossom": "张开的眼眸花",
  "block.minecraft.orange_banner": "橙色旗帜",
  "block.minecraft.orange_bed": "橙色床",
  "block.minecraft.orange_candle": "橙色蜡烛",
  "block.minecraft.orange_candle_cake": "插上橙色蜡烛的蛋糕",
  "block.minecraft.orange_carpet": "橙色地毯",
  "block.minecraft.orange_concrete": "橙色混凝土",
  "block.minecraft.orange_concrete_powder": "橙色混凝土粉末",
  "block.minecraft.orange_glazed_terracotta": "橙色带釉陶瓦",
  "block.minecraft.orange_shulker_box": "橙色潜影盒",
  "block.minecraft.orange_stained_glass": "橙色染色玻璃",
  "block.minecraft.orange_stained_glass_pane": "橙色染色玻璃板",
  "block.minecraft.orange_terracotta": "橙色陶瓦",
  "block.minecraft.orange_tulip": "橙色郁金香",
  "block.minecraft.orange_wool": "橙色羊毛",
  "block.minecraft.oxeye_daisy": "滨菊",
  "block.minecraft.oxidized_chiseled_copper": "氧化的雕纹铜块",
  "block.minecraft.oxidized_copper": "氧化的铜块",
  "block.minecraft.oxidized_copper_bars": "氧化的铜栏杆",
  "block.minecraft.oxidized_copper_bulb": "氧化的铜灯",
  "block.minecraft.oxidized_copper_chain": "氧化的铜链",
  "block.minecraft.oxidized_copper_chest": "氧化的铜箱子",
  "block.minecraft.oxidized_copper_door": "氧化的铜门",
  "block.minecraft.oxidized_copper_golem_statue": "氧化的铜傀儡像",
  "block.minecraft.oxidized_copper_grate": "氧化的铜格栅",
  "block.minecraft.oxidized_copper_lantern": "氧化的铜灯笼",
  "block.minecraft.oxidized_copper_trapdoor": "氧化的铜活板门",
  "block.minecraft.oxidized_cut_copper": "氧化的切制铜块",
  "block.minecraft.oxidized_cut_copper_slab": "氧化的切制铜台阶",
  "block.minecraft.oxidized_cut_copper_stairs": "氧化的切制铜楼梯",
  "block.minecraft.oxidized_lightning_rod": "氧化的避雷针",
  "block.minecraft.packed_ice": "浮冰",
  "block.minecraft.packed_mud": "泥坯",
  "block.minecraft.pale_hanging_moss": "苍白垂须",
  "block.minecraft.pale_moss_block": "苍白苔藓块",
  "block.minecraft.pale_moss_carpet": "苍白覆地苔藓",
  "block.minecraft.pale_oak_button": "苍白橡木按钮",
  "block.minecraft.pale_oak_door": "苍白橡木门",
  "block.minecraft.pale_oak_fence": "苍白橡木栅栏",
  "block.minecraft.pale_oak_fence_gate": "苍白橡木栅栏门",
  "block.minecraft.pale_oak_hanging_sign": "悬挂式苍白橡木告示牌",
  "block.minecraft.pale_oak_leaves": "苍白橡树树叶",
  "block.minecraft.pale_oak_log": "苍白橡木原木",
  "block.minecraft.pale_oak_planks": "苍白橡木木板",
  "block.minecraft.pale_oak_pressure_plate": "苍白橡木压力板",
  "block.minecraft.pale_oak_sapling": "苍白橡树树苗",
  "block.minecraft.pale_oak_shelf": "苍白橡木展示架",
  "block.minecraft.pale_oak_sign": "苍白橡木告示牌",
  "block.minecraft.pale_oak_slab": "苍白橡木台阶",
  "block.minecraft.pale_oak_stairs": "苍白橡木楼梯",
  "block.minecraft.pale_oak_trapdoor": "苍白橡木活板门",
  "block.minecraft.pale_oak_wall_hanging_sign": "墙上的悬挂式苍白橡木告示牌",
  "block.minecraft.pale_oak_wall_sign": "墙上的苍白橡木告示牌",
  "block.minecraft.pale_oak_wood": "苍白橡木",
  "block.minecraft.pearlescent_froglight": "珠光蛙明灯",
  "block.minecraft.peony": "牡丹",
  "block.minecraft.petrified_oak_slab": "石化橡木台阶",
  "block.minecraft.piglin_head": "猪灵的头",
  "block.minecraft.piglin_wall_head": "墙上的猪灵的头",
  "block.minecraft.pink_banner": "粉红色旗帜",
  "block.minecraft.pink_bed": "粉红色床",
  "block.minecraft.pink_candle": "粉红色蜡烛",
  "block.minecraft.pink_candle_cake": "插上粉红色蜡烛的蛋糕",
  "block.minecraft.pink_carpet": "粉红色地毯",
  "block.minecraft.pink_concrete": "粉红色混凝土",
  "block.minecraft.pink_concrete_powder": "粉红色混凝土粉末",
  "block.minecraft.pink_glazed_terracotta": "粉红色带釉陶瓦",
  "block.minecraft.pink_petals": "粉红色花簇",
  "block.minecraft.pink_shulker_box": "粉红色潜影盒",
  "block.minecraft.pink_stained_glass": "粉红色染色玻璃",
  "block.minecraft.pink_stained_glass_pane": "粉红色染色玻璃板",
  "block.minecraft.pink_terracotta": "粉红色陶瓦",
  "block.minecraft.pink_tulip": "粉红色郁金香",
  "block.minecraft.pink_wool": "粉红色羊毛",
  "block.minecraft.piston": "活塞",
  "block.minecraft.piston_head": "活塞头",
  "block.minecraft.pitcher_crop": "瓶子草植株",
  "block.minecraft.pitcher_plant": "瓶子草",
  "block.minecraft.player_head": "玩家的头",
  "block.minecraft.player_head.named": "%s的头",
  "block.minecraft.player_wall_head": "墙上的玩家的头",
  "block.minecraft.podzol": "灰化土",
  "block.minecraft.pointed_dripstone": "滴水石锥",
  "block.minecraft.polished_andesite": "磨制安山岩",
  "block.minecraft.polished_andesite_slab": "磨制安山岩台阶",
  "block.minecraft.polished_andesite_stairs": "磨制安山岩楼梯",
  "block.minecraft.polished_basalt": "磨制玄武岩",
  "block.minecraft.polished_blackstone": "磨制黑石",
  "block.minecraft.polished_blackstone_brick_slab": "磨制黑石砖台阶",
  "block.minecraft.polished_blackstone_brick_stairs": "磨制黑石砖楼梯",
  "block.minecraft.polished_blackstone_brick_wall": "磨制黑石砖墙",
  "block.minecraft.polished_blackstone_bricks": "磨制黑石砖",
  "block.minecraft.polished_blackstone_button": "磨制黑石按钮",
  "block.minecraft.polished_blackstone_pressure_plate": "磨制黑石压力板",
  "block.minecraft.polished_blackstone_slab": "磨制黑石台阶",
  "block.minecraft.polished_blackstone_stairs": "磨制黑石楼梯",
  "block.minecraft.polished_blackstone_wall": "磨制黑石墙",
  "block.minecraft.polished_deepslate": "磨制深板岩",
  "block.minecraft.polished_deepslate_slab": "磨制深板岩台阶",
  "block.minecraft.polished_deepslate_stairs": "磨制深板岩楼梯",
  "block.minecraft.polished_deepslate_wall": "磨制深板岩墙",
  "block.minecraft.polished_diorite": "磨制闪长岩",
  "block.minecraft.polished_diorite_slab": "磨制闪长岩台阶",
  "block.minecraft.polished_diorite_stairs": "磨制闪长岩楼梯",
  "block.minecraft.polished_granite": "磨制花岗岩",
  "block.minecraft.polished_granite_slab": "磨制花岗岩台阶",
  "block.minecraft.polished_granite_stairs": "磨制花岗岩楼梯",
  "block.minecraft.polished_tuff": "磨制凝灰岩",
  "block.minecraft.polished_tuff_slab": "磨制凝灰岩台阶",
  "block.minecraft.polished_tuff_stairs": "磨制凝灰岩楼梯",
  "block.minecraft.polished_tuff_wall": "磨制凝灰岩墙",
  "block.minecraft.poppy": "虞美人",
  "block.minecraft.potatoes": "马铃薯",
  "block.minecraft.potted_acacia_sapling": "金合欢树苗盆栽",
  "block.minecraft.potted_allium": "绒球葱盆栽",
  "block.minecraft.potted_azalea_bush": "杜鹃花丛盆栽",
  "block.minecraft.potted_azure_bluet": "蓝花美耳草盆栽",
  "block.minecraft.potted_bamboo": "竹子盆栽",
  "block.minecraft.potted_birch_sapling": "白桦树苗盆栽",
  "block.minecraft.potted_blue_orchid": "兰花盆栽",
  "block.minecraft.potted_brown_mushroom": "棕色蘑菇盆栽",
  "block.minecraft.potted_cactus": "仙人掌盆栽",
  "block.minecraft.potted_cherry_sapling": "樱花树苗盆栽",
  "block.minecraft.potted_closed_eyeblossom": "闭合的眼眸花盆栽",
  "block.minecraft.potted_cornflower": "矢车菊盆栽",
  "block.minecraft.potted_crimson_fungus": "绯红菌盆栽",
  "block.minecraft.potted_crimson_roots": "绯红菌索盆栽",
  "block.minecraft.potted_dandelion": "蒲公英盆栽",
  "block.minecraft.potted_dark_oak_sapling": "深色橡树树苗盆栽",
  "block.minecraft.potted_dead_bush": "枯萎的灌木盆栽",
  "block.minecraft.potted_fern": "蕨盆栽",
  "block.minecraft.potted_flowering_azalea_bush": "盛开的杜鹃花丛盆栽",
  "block.minecraft.potted_golden_dandelion": "金蒲公英盆栽",
  "block.minecraft.potted_jungle_sapling": "丛林树苗盆栽",
  "block.minecraft.potted_lily_of_the_valley": "铃兰盆栽",
  "block.minecraft.potted_mangrove_propagule": "红树胎生苗盆栽",
  "block.minecraft.potted_oak_sapling": "橡树树苗盆栽",
  "block.minecraft.potted_open_eyeblossom": "张开的眼眸花盆栽",
  "block.minecraft.potted_orange_tulip": "橙色郁金香盆栽",
  "block.minecraft.potted_oxeye_daisy": "滨菊盆栽",
  "block.minecraft.potted_pale_oak_sapling": "苍白橡树树苗盆栽",
  "block.minecraft.potted_pink_tulip": "粉红色郁金香盆栽",
  "block.minecraft.potted_poppy": "虞美人盆栽",
  "block.minecraft.potted_red_mushroom": "红色蘑菇盆栽",
  "block.minecraft.potted_red_tulip": "红色郁金香盆栽",
  "block.minecraft.potted_spruce_sapling": "云杉树苗盆栽",
  "block.minecraft.potted_torchflower": "火把花盆栽",
  "block.minecraft.potted_warped_fungus": "诡异菌盆栽",
  "block.minecraft.potted_warped_roots": "诡异菌索盆栽",
  "block.minecraft.potted_white_tulip": "白色郁金香盆栽",
  "block.minecraft.potted_wither_rose": "凋灵玫瑰盆栽",
  "block.minecraft.powder_snow": "细雪",
  "block.minecraft.powder_snow_cauldron": "装有细雪的炼药锅",
  "block.minecraft.powered_rail": "动力铁轨",
  "block.minecraft.prismarine": "海晶石",
  "block.minecraft.prismarine_brick_slab": "海晶石砖台阶",
  "block.minecraft.prismarine_brick_stairs": "海晶石砖楼梯",
  "block.minecraft.prismarine_bricks": "海晶石砖",
  "block.minecraft.prismarine_slab": "海晶石台阶",
  "block.minecraft.prismarine_stairs": "海晶石楼梯",
  "block.minecraft.prismarine_wall": "海晶石墙",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.pumpkin_stem": "南瓜茎",
  "block.minecraft.purple_banner": "紫色旗帜",
  "block.minecraft.purple_bed": "紫色床",
  "block.minecraft.purple_candle": "紫色蜡烛",
  "block.minecraft.purple_candle_cake": "插上紫色蜡烛的蛋糕",
  "block.minecraft.purple_carpet": "紫色地毯",
  "block.minecraft.purple_concrete": "紫色混凝土",
  "block.minecraft.purple_concrete_powder": "紫色混凝土粉末",
  "block.minecraft.purple_glazed_terracotta": "紫色带釉陶瓦",
  "block.minecraft.purple_shulker_box": "紫色潜影盒",
  "block.minecraft.purple_stained_glass": "紫色染色玻璃",
  "block.minecraft.purple_stained_glass_pane": "紫色染色玻璃板",
  "block.minecraft.purple_terracotta": "紫色陶瓦",
  "block.minecraft.purple_wool": "紫色羊毛",
  "block.minecraft.purpur_block": "紫珀块",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_slab": "紫珀台阶",
  "block.minecraft.purpur_stairs": "紫珀楼梯",
  "block.minecraft.quartz_block": "石英块",
  "block.minecraft.quartz_bricks": "石英砖",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_slab": "石英台阶",
  "block.minecraft.quartz_stairs": "石英楼梯",
  "block.minecraft.rail": "铁轨",
  "block.minecraft.raw_copper_block": "粗铜块",
  "block.minecraft.raw_gold_block": "粗金块",
  "block.minecraft.raw_iron_block": "粗铁块",
  "block.minecraft.red_banner": "红色旗帜",
  "block.minecraft.red_bed": "红色床",
  "block.minecraft.red_candle": "红色蜡烛",
  "block.minecraft.red_candle_cake": "插上红色蜡烛的蛋糕",
  "block.minecraft.red_carpet": "红色地毯",
  "block.minecraft.red_concrete": "红色混凝土",
  "block.minecraft.red_concrete_powder": "红色混凝土粉末",
  "block.minecraft.red_glazed_terracotta": "红色带釉陶瓦",
  "block.minecraft.red_mushroom": "红色蘑菇",
  "block.minecraft.red_mushroom_block": "红色蘑菇方块",
  "block.minecraft.red_nether_brick_slab": "红色下界砖台阶",
  "block.minecraft.red_nether_brick_stairs": "红色下界砖楼梯",
  "block.minecraft.red_nether_brick_wall": "红色下界砖墙",
  "block.minecraft.red_nether_bricks": "红色下界砖块",
  "block.minecraft.red_sand": "红沙",
  "block.minecraft.red_sandstone": "红砂岩",
  "block.minecraft.red_sandstone_slab": "红砂岩台阶",
  "block.minecraft.red_sandstone_stairs": "红砂岩楼梯",
  "block.minecraft.red_sandstone_wall": "红砂岩墙",
  "block.minecraft.red_shulker_box": "红色潜影盒",
  "block.minecraft.red_stained_glass": "红色染色玻璃",
  "block.minecraft.red_stained_glass_pane": "红色染色玻璃板",
  "block.minecraft.red_terracotta": "红色陶瓦",
  "block.minecraft.red_tulip": "红色郁金香",
  "block.minecraft.red_wool": "红色羊毛",
  "block.minecraft.redstone_block": "红石块",
  "block.minecraft.redstone_lamp": "红石灯",
  "block.minecraft.redstone_ore": "红石矿石",
  "block.minecraft.redstone_torch": "红石火把",
  "block.minecraft.redstone_wall_torch": "墙上的红石火把",
  "block.minecraft.redstone_wire": "红石线",
  "block.minecraft.reinforced_deepslate": "强化深板岩",
  "block.minecraft.repeater": "红石中继器",
  "block.minecraft.repeating_command_block": "循环型命令方块",
  "block.minecraft.resin_block": "树脂块",
  "block.minecraft.resin_brick_slab": "树脂砖台阶",
  "block.minecraft.resin_brick_stairs": "树脂砖楼梯",
  "block.minecraft.resin_brick_wall": "树脂砖墙",
  "block.minecraft.resin_bricks": "树脂砖块",
  "block.minecraft.resin_clump": "树脂团",
  "block.minecraft.respawn_anchor": "重生锚",
  "block.minecraft.rooted_dirt": "缠根泥土",
  "block.minecraft.rose_bush": "玫瑰丛",
  "block.minecraft.sand": "沙子",
  "block.minecraft.sandstone": "砂岩",
  "block.minecraft.sandstone_slab": "砂岩台阶",
  "block.minecraft.sandstone_stairs": "砂岩楼梯",
  "block.minecraft.sandstone_wall": "砂岩墙",
  "block.minecraft.scaffolding": "脚手架",
  "block.minecraft.sculk": "幽匿块",
  "block.minecraft.sculk_catalyst": "幽匿催发体",
  "block.minecraft.sculk_sensor": "幽匿感测体",
  "block.minecraft.sculk_shrieker": "幽匿尖啸体",
  "block.minecraft.sculk_vein": "幽匿脉络",
  "block.minecraft.sea_lantern": "海晶灯",
  "block.minecraft.sea_pickle": "海泡菜",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.set_spawn": "已设置重生点",
  "block.minecraft.short_dry_grass": "矮枯草丛",
  "block.minecraft.short_grass": "矮草丛",
  "block.minecraft.shroomlight": "菌光体",
  "block.minecraft.shulker_box": "潜影盒",
  "block.minecraft.skeleton_skull": "骷髅头颅",
  "block.minecraft.skeleton_wall_skull": "墙上的骷髅头颅",
  "block.minecraft.slime_block": "黏液块",
  "block.minecraft.small_amethyst_bud": "小型紫晶芽",
  "block.minecraft.small_dripleaf": "小型垂滴叶",
  "block.minecraft.smithing_table": "锻造台",
  "block.minecraft.smoker": "烟熏炉",
  "block.minecraft.smooth_basalt": "平滑玄武岩",
  "block.minecraft.smooth_quartz": "平滑石英块",
  "block.minecraft.smooth_quartz_slab": "平滑石英台阶",
  "block.minecraft.smooth_quartz_stairs": "平滑石英楼梯",
  "block.minecraft.smooth_red_sandstone": "平滑红砂岩",
  "block.minecraft.smooth_red_sandstone_slab": "平滑红砂岩台阶",
  "block.minecraft.smooth_red_sandstone_stairs": "平滑红砂岩楼梯",
  "block.minecraft.smooth_sandstone": "平滑砂岩",
  "block.minecraft.smooth_sandstone_slab": "平滑砂岩台阶",
  "block.minecraft.smooth_sandstone_stairs": "平滑砂岩楼梯",
  "block.minecraft.smooth_stone": "平滑石头",
  "block.minecraft.smooth_stone_slab": "平滑石头台阶",
  "block.minecraft.sniffer_egg": "嗅探兽蛋",
  "block.minecraft.snow": "雪",
  "block.minecraft.snow_block": "雪块",
  "block.minecraft.soul_campfire": "灵魂营火",
  "block.minecraft.soul_fire": "灵魂火",
  "block.minecraft.soul_lantern": "灵魂灯笼",
  "block.minecraft.soul_sand": "灵魂沙",
  "block.minecraft.soul_soil": "灵魂土",
  "block.minecraft.soul_torch": "灵魂火把",
  "block.minecraft.soul_wall_torch": "墙上的灵魂火把",
  "block.minecraft.spawn.not_valid": "你的床或已充能的重生锚不存在或已被阻挡",
  "block.minecraft.spawner": "刷怪笼",
  "block.minecraft.spawner.desc1": "用刷怪蛋交互时：",
  "block.minecraft.spawner.desc2": "设置生物种类",
  "block.minecraft.sponge": "海绵",
  "block.minecraft.spore_blossom": "孢子花",
  "block.minecraft.spruce_button": "云杉木按钮",
  "block.minecraft.spruce_door": "云杉木门",
  "block.minecraft.spruce_fence": "云杉木栅栏",
  "block.minecraft.spruce_fence_gate": "云杉木栅栏门",
  "block.minecraft.spruce_hanging_sign": "悬挂式云杉木告示牌",
  "block.minecraft.spruce_leaves": "云杉树叶",
  "block.minecraft.spruce_log": "云杉原木",
  "block.minecraft.spruce_planks": "云杉木板",
  "block.minecraft.spruce_pressure_plate": "云杉木压力板",
  "block.minecraft.spruce_sapling": "云杉树苗",
  "block.minecraft.spruce_shelf": "云杉木展示架",
  "block.minecraft.spruce_sign": "云杉木告示牌",
  "block.minecraft.spruce_slab": "云杉木台阶",
  "block.minecraft.spruce_stairs": "云杉木楼梯",
  "block.minecraft.spruce_trapdoor": "云杉木活板门",
  "block.minecraft.spruce_wall_hanging_sign": "墙上的悬挂式云杉木告示牌",
  "block.minecraft.spruce_wall_sign": "墙上的云杉木告示牌",
  "block.minecraft.spruce_wood": "云杉木",
  "block.minecraft.sticky_piston": "黏性活塞",
  "block.minecraft.stone": "石头",
  "block.minecraft.stone_brick_slab": "石砖台阶",
  "block.minecraft.stone_brick_stairs": "石砖楼梯",
  "block.minecraft.stone_brick_wall": "石砖墙",
  "block.minecraft.stone_bricks": "石砖",
  "block.minecraft.stone_button": "石头按钮",
  "block.minecraft.stone_pressure_plate": "石头压力板",
  "block.minecraft.stone_slab": "石头台阶",
  "block.minecraft.stone_stairs": "石头楼梯",
  "block.minecraft.stonecutter": "切石机",
  "block.minecraft.stripped_acacia_log": "去皮金合欢原木",
  "block.minecraft.stripped_acacia_wood": "去皮金合欢木",
  "block.minecraft.stripped_bamboo_block": "去皮竹块",
  "block.minecraft.stripped_birch_log": "去皮白桦原木",
  "block.minecraft.stripped_birch_wood": "去皮白桦木",
  "block.minecraft.stripped_cherry_log": "去皮樱花原木",
  "block.minecraft.stripped_cherry_wood": "去皮樱花木",
  "block.minecraft.stripped_crimson_hyphae": "去皮绯红菌核",
  "block.minecraft.stripped_crimson_stem": "去皮绯红菌柄",
  "block.minecraft.stripped_dark_oak_log": "去皮深色橡木原木",
  "block.minecraft.stripped_dark_oak_wood": "去皮深色橡木",
  "block.minecraft.stripped_jungle_log": "去皮丛林原木",
  "block.minecraft.stripped_jungle_wood": "去皮丛林木",
  "block.minecraft.stripped_mangrove_log": "去皮红树原木",
  "block.minecraft.stripped_mangrove_wood": "去皮红树木",
  "block.minecraft.stripped_oak_log": "去皮橡木原木",
  "block.minecraft.stripped_oak_wood": "去皮橡木",
  "block.minecraft.stripped_pale_oak_log": "去皮苍白橡木原木",
  "block.minecraft.stripped_pale_oak_wood": "去皮苍白橡木",
  "block.minecraft.stripped_spruce_log": "去皮云杉原木",
  "block.minecraft.stripped_spruce_wood": "去皮云杉木",
  "block.minecraft.stripped_warped_hyphae": "去皮诡异菌核",
  "block.minecraft.stripped_warped_stem": "去皮诡异菌柄",
  "block.minecraft.structure_block": "结构方块",
  "block.minecraft.structure_void": "结构空位",
  "block.minecraft.sugar_cane": "甘蔗",
  "block.minecraft.sunflower": "向日葵",
  "block.minecraft.suspicious_gravel": "可疑的沙砾",
  "block.minecraft.suspicious_sand": "可疑的沙子",
  "block.minecraft.sweet_berry_bush": "甜浆果丛",
  "block.minecraft.tall_dry_grass": "高枯草丛",
  "block.minecraft.tall_grass": "高草丛",
  "block.minecraft.tall_seagrass": "高海草",
  "block.minecraft.target": "标靶",
  "block.minecraft.terracotta": "陶瓦",
  "block.minecraft.test_block": "测试方块",
  "block.minecraft.test_instance_block": "测试实例方块",
  "block.minecraft.tinted_glass": "遮光玻璃",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT爆炸已禁用",
  "block.minecraft.torch": "火把",
  "block.minecraft.torchflower": "火把花",
  "block.minecraft.torchflower_crop": "火把花植株",
  "block.minecraft.trapped_chest": "陷阱箱",
  "block.minecraft.trial_spawner": "试炼刷怪笼",
  "block.minecraft.tripwire": "绊线",
  "block.minecraft.tripwire_hook": "绊线钩",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.tube_coral_block": "管珊瑚块",
  "block.minecraft.tube_coral_fan": "管珊瑚扇",
  "block.minecraft.tube_coral_wall_fan": "墙上的管珊瑚扇",
  "block.minecraft.tuff": "凝灰岩",
  "block.minecraft.tuff_brick_slab": "凝灰岩砖台阶",
  "block.minecraft.tuff_brick_stairs": "凝灰岩砖楼梯",
  "block.minecraft.tuff_brick_wall": "凝灰岩砖墙",
  "block.minecraft.tuff_bricks": "凝灰岩砖",
  "block.minecraft.tuff_slab": "凝灰岩台阶",
  "block.minecraft.tuff_stairs": "凝灰岩楼梯",
  "block.minecraft.tuff_wall": "凝灰岩墙",
  "block.minecraft.turtle_egg": "海龟蛋",
  "block.minecraft.twisting_vines": "缠怨藤",
  "block.minecraft.twisting_vines_plant": "缠怨藤植株",
  "block.minecraft.vault": "宝库",
  "block.minecraft.verdant_froglight": "青翠蛙明灯",
  "block.minecraft.vine": "藤蔓",
  "block.minecraft.void_air": "虚空空气",
  "block.minecraft.wall_torch": "墙上的火把",
  "block.minecraft.warped_button": "诡异木按钮",
  "block.minecraft.warped_door": "诡异木门",
  "block.minecraft.warped_fence": "诡异木栅栏",
  "block.minecraft.warped_fence_gate": "诡异木栅栏门",
  "block.minecraft.warped_fungus": "诡异菌",
  "block.minecraft.warped_hanging_sign": "悬挂式诡异木告示牌",
  "block.minecraft.warped_hyphae": "诡异菌核",
  "block.minecraft.warped_nylium": "诡异菌岩",
  "block.minecraft.warped_planks": "诡异木板",
  "block.minecraft.warped_pressure_plate": "诡异木压力板",
  "block.minecraft.warped_roots": "诡异菌索",
  "block.minecraft.warped_shelf": "诡异木展示架",
  "block.minecraft.warped_sign": "诡异木告示牌",
  "block.minecraft.warped_slab": "诡异木台阶",
  "block.minecraft.warped_stairs": "诡异木楼梯",
  "block.minecraft.warped_stem": "诡异菌柄",
  "block.minecraft.warped_trapdoor": "诡异木活板门",
  "block.minecraft.warped_wall_hanging_sign": "墙上的悬挂式诡异木告示牌",
  "block.minecraft.warped_wall_sign": "墙上的诡异木告示牌",
  "block.minecraft.warped_wart_block": "诡异疣块",
  "block.minecraft.water": "水",
  "block.minecraft.water_cauldron": "装有水的炼药锅",
  "block.minecraft.waxed_chiseled_copper": "涂蜡的雕纹铜块",
  "block.minecraft.waxed_copper_bars": "涂蜡的铜栏杆",
  "block.minecraft.waxed_copper_block": "涂蜡的铜块",
  "block.minecraft.waxed_copper_bulb": "涂蜡的铜灯",
  "block.minecraft.waxed_copper_chain": "涂蜡的铜链",
  "block.minecraft.waxed_copper_chest": "涂蜡的铜箱子",
  "block.minecraft.waxed_copper_door": "涂蜡的铜门",
  "block.minecraft.waxed_copper_golem_statue": "涂蜡的铜傀儡像",
  "block.minecraft.waxed_copper_grate": "涂蜡的铜格栅",
  "block.minecraft.waxed_copper_lantern": "涂蜡的铜灯笼",
  "block.minecraft.waxed_copper_trapdoor": "涂蜡的铜活板门",
  "block.minecraft.waxed_cut_copper": "涂蜡的切制铜块",
  "block.minecraft.waxed_cut_copper_slab": "涂蜡的切制铜台阶",
  "block.minecraft.waxed_cut_copper_stairs": "涂蜡的切制铜楼梯",
  "block.minecraft.waxed_exposed_chiseled_copper": "涂蜡的斑驳雕纹铜块",
  "block.minecraft.waxed_exposed_copper": "涂蜡的斑驳铜块",
  "block.minecraft.waxed_exposed_copper_bars": "涂蜡的斑驳铜栏杆",
  "block.minecraft.waxed_exposed_copper_bulb": "涂蜡的斑驳铜灯",
  "block.minecraft.waxed_exposed_copper_chain": "涂蜡的斑驳铜链",
  "block.minecraft.waxed_exposed_copper_chest": "涂蜡的斑驳铜箱子",
  "block.minecraft.waxed_exposed_copper_door": "涂蜡的斑驳铜门",
  "block.minecraft.waxed_exposed_copper_golem_statue": "涂蜡的斑驳铜傀儡像",
  "block.minecraft.waxed_exposed_copper_grate": "涂蜡的斑驳铜格栅",
  "block.minecraft.waxed_exposed_copper_lantern": "涂蜡的斑驳铜灯笼",
  "block.minecraft.waxed_exposed_copper_trapdoor": "涂蜡的斑驳铜活板门",
  "block.minecraft.waxed_exposed_cut_copper": "涂蜡的斑驳切制铜块",
  "block.minecraft.waxed_exposed_cut_copper_slab": "涂蜡的斑驳切制铜台阶",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "涂蜡的斑驳切制铜楼梯",
  "block.minecraft.waxed_exposed_lightning_rod": "涂蜡的斑驳避雷针",
  "block.minecraft.waxed_lightning_rod": "涂蜡的避雷针",
  "block.minecraft.waxed_oxidized_chiseled_copper": "涂蜡的氧化雕纹铜块",
  "block.minecraft.waxed_oxidized_copper": "涂蜡的氧化铜块",
  "block.minecraft.waxed_oxidized_copper_bars": "涂蜡的氧化铜栏杆",
  "block.minecraft.waxed_oxidized_copper_bulb": "涂蜡的氧化铜灯",
  "block.minecraft.waxed_oxidized_copper_chain": "涂蜡的氧化铜链",
  "block.minecraft.waxed_oxidized_copper_chest": "涂蜡的氧化铜箱子",
  "block.minecraft.waxed_oxidized_copper_door": "涂蜡的氧化铜门",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "涂蜡的氧化铜傀儡像",
  "block.minecraft.waxed_oxidized_copper_grate": "涂蜡的氧化铜格栅",
  "block.minecraft.waxed_oxidized_copper_lantern": "涂蜡的氧化铜灯笼",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "涂蜡的氧化铜活板门",
  "block.minecraft.waxed_oxidized_cut_copper": "涂蜡的氧化切制铜块",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "涂蜡的氧化切制铜台阶",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "涂蜡的氧化切制铜楼梯",
  "block.minecraft.waxed_oxidized_lightning_rod": "涂蜡的氧化避雷针",
  "block.minecraft.waxed_weathered_chiseled_copper": "涂蜡的锈蚀雕纹铜块",
  "block.minecraft.waxed_weathered_copper": "涂蜡的锈蚀铜块",
  "block.minecraft.waxed_weathered_copper_bars": "涂蜡的锈蚀铜栏杆",
  "block.minecraft.waxed_weathered_copper_bulb": "涂蜡的锈蚀铜灯",
  "block.minecraft.waxed_weathered_copper_chain": "涂蜡的锈蚀铜链",
  "block.minecraft.waxed_weathered_copper_chest": "涂蜡的锈蚀铜箱子",
  "block.minecraft.waxed_weathered_copper_door": "涂蜡的锈蚀铜门",
  "block.minecraft.waxed_weathered_copper_golem_statue": "涂蜡的锈蚀铜傀儡像",
  "block.minecraft.waxed_weathered_copper_grate": "涂蜡的锈蚀铜格栅",
  "block.minecraft.waxed_weathered_copper_lantern": "涂蜡的锈蚀铜灯笼",
  "block.minecraft.waxed_weathered_copper_trapdoor": "涂蜡的锈蚀铜活板门",
  "block.minecraft.waxed_weathered_cut_copper": "涂蜡的锈蚀切制铜块",
  "block.minecraft.waxed_weathered_cut_copper_slab": "涂蜡的锈蚀切制铜台阶",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "涂蜡的锈蚀切制铜楼梯",
  "block.minecraft.waxed_weathered_lightning_rod": "涂蜡的锈蚀避雷针",
  "block.minecraft.weathered_chiseled_copper": "锈蚀的雕纹铜块",
  "block.minecraft.weathered_copper": "锈蚀的铜块",
  "block.minecraft.weathered_copper_bars": "锈蚀的铜栏杆",
  "block.minecraft.weathered_copper_bulb": "锈蚀的铜灯",
  "block.minecraft.weathered_copper_chain": "锈蚀的铜链",
  "block.minecraft.weathered_copper_chest": "锈蚀的铜箱子",
  "block.minecraft.weathered_copper_door": "锈蚀的铜门",
  "block.minecraft.weathered_copper_golem_statue": "锈蚀的铜傀儡像",
  "block.minecraft.weathered_copper_grate": "锈蚀的铜格栅",
  "block.minecraft.weathered_copper_lantern": "锈蚀的铜灯笼",
  "block.minecraft.weathered_copper_trapdoor": "锈蚀的铜活板门",
  "block.minecraft.weathered_cut_copper": "锈蚀的切制铜块",
  "block.minecraft.weathered_cut_copper_slab": "锈蚀的切制铜台阶",
  "block.minecraft.weathered_cut_copper_stairs": "锈蚀的切制铜楼梯",
  "block.minecraft.weathered_lightning_rod": "锈蚀的避雷针",
  "block.minecraft.weeping_vines": "垂泪藤",
  "block.minecraft.weeping_vines_plant": "垂泪藤植株",
  "block.minecraft.wet_sponge": "湿海绵",
  "block.minecraft.wheat": "小麦植株",
  "block.minecraft.white_banner": "白色旗帜",
  "block.minecraft.white_bed": "白色床",
  "block.minecraft.white_candle": "白色蜡烛",
  "block.minecraft.white_candle_cake": "插上白色蜡烛的蛋糕",
  "block.minecraft.white_carpet": "白色地毯",
  "block.minecraft.white_concrete": "白色混凝土",
  "block.minecraft.white_concrete_powder": "白色混凝土粉末",
  "block.minecraft.white_glazed_terracotta": "白色带釉陶瓦",
  "block.minecraft.white_shulker_box": "白色潜影盒",
  "block.minecraft.white_stained_glass": "白色染色玻璃",
  "block.minecraft.white_stained_glass_pane": "白色染色玻璃板",
  "block.minecraft.white_terracotta": "白色陶瓦",
  "block.minecraft.white_tulip": "白色郁金香",
  "block.minecraft.white_wool": "白色羊毛",
  "block.minecraft.wildflowers": "野花簇",
  "block.minecraft.wither_rose": "凋灵玫瑰",
  "block.minecraft.wither_skeleton_skull": "凋灵骷髅头颅",
  "block.minecraft.wither_skeleton_wall_skull": "墙上的凋灵骷髅头颅",
  "block.minecraft.yellow_banner": "黄色旗帜",
  "block.minecraft.yellow_bed": "黄色床",
  "block.minecraft.yellow_candle": "黄色蜡烛",
  "block.minecraft.yellow_candle_cake": "插上黄色蜡烛的蛋糕",
  "block.minecraft.yellow_carpet": "黄色地毯",
  "block.minecraft.yellow_concrete": "黄色混凝土",
  "block.minecraft.yellow_concrete_powder": "黄色混凝土粉末",
  "block.minecraft.yellow_glazed_terracotta": "黄色带釉陶瓦",
  "block.minecraft.yellow_shulker_box": "黄色潜影盒",
  "block.minecraft.yellow_stained_glass": "黄色染色玻璃",
  "block.minecraft.yellow_stained_glass_pane": "黄色染色玻璃板",
  "block.minecraft.yellow_terracotta": "黄色陶瓦",
  "block.minecraft.yellow_wool": "黄色羊毛",
  "block.minecraft.zombie_head": "僵尸的头",
  "block.minecraft.zombie_wall_head": "墙上的僵尸的头",
  "item.minecraft.acacia_boat": "金合欢木船",
  "item.minecraft.acacia_chest_boat": "金合欢木运输船",
  "item.minecraft.allay_spawn_egg": "悦灵刷怪蛋",
  "item.minecraft.amethyst_shard": "紫水晶碎片",
  "item.minecraft.angler_pottery_shard": "垂钓纹样陶片",
  "item.minecraft.angler_pottery_sherd": "垂钓纹样陶片",
  "item.minecraft.apple": "苹果",
  "item.minecraft.archer_pottery_shard": "弓箭纹样陶片",
  "item.minecraft.archer_pottery_sherd": "弓箭纹样陶片",
  "item.minecraft.armadillo_scute": "犰狳鳞甲",
  "item.minecraft.armadillo_spawn_egg": "犰狳刷怪蛋",
  "item.minecraft.armor_stand": "盔甲架",
  "item.minecraft.arms_up_pottery_shard": "举臂纹样陶片",
  "item.minecraft.arms_up_pottery_sherd": "举臂纹样陶片",
  "item.minecraft.arrow": "箭",
  "item.minecraft.axolotl_bucket": "美西螈桶",
  "item.minecraft.axolotl_spawn_egg": "美西螈刷怪蛋",
  "item.minecraft.baked_potato": "烤马铃薯",
  "item.minecraft.bamboo_chest_raft": "运输竹筏",
  "item.minecraft.bamboo_raft": "竹筏",
  "item.minecraft.bat_spawn_egg": "蝙蝠刷怪蛋",
  "item.minecraft.bee_spawn_egg": "蜜蜂刷怪蛋",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.beetroot": "甜菜根",
  "item.minecraft.beetroot_seeds": "甜菜种子",
  "item.minecraft.beetroot_soup": "甜菜汤",
  "item.minecraft.birch_boat": "白桦木船",
  "item.minecraft.birch_chest_boat": "白桦木运输船",
  "item.minecraft.black_bundle": "黑色收纳袋",
  "item.minecraft.black_dye": "黑色染料",
  "item.minecraft.black_harness": "黑色挽具",
  "item.minecraft.blade_pottery_shard": "利刃纹样陶片",
  "item.minecraft.blade_pottery_sherd": "利刃纹样陶片",
  "item.minecraft.blaze_powder": "烈焰粉",
  "item.minecraft.blaze_rod": "烈焰棒",
  "item.minecraft.blaze_spawn_egg": "烈焰人刷怪蛋",
  "item.minecraft.blue_bundle": "蓝色收纳袋",
  "item.minecraft.blue_dye": "蓝色染料",
  "item.minecraft.blue_egg": "蓝色鸡蛋",
  "item.minecraft.blue_harness": "蓝色挽具",
  "item.minecraft.bogged_spawn_egg": "沼骸刷怪蛋",
  "item.minecraft.bolt_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "镶铆盔甲纹饰",
  "item.minecraft.bone": "骨头",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.book": "书",
  "item.minecraft.bordure_indented_banner_pattern": "波纹边旗帜图案",
  "item.minecraft.bow": "弓",
  "item.minecraft.bowl": "碗",
  "item.minecraft.bread": "面包",
  "item.minecraft.breeze_rod": "旋风棒",
  "item.minecraft.breeze_spawn_egg": "旋风人刷怪蛋",
  "item.minecraft.brewer_pottery_shard": "佳酿纹样陶片",
  "item.minecraft.brewer_pottery_sherd": "佳酿纹样陶片",
  "item.minecraft.brewing_stand": "酿造台",
  "item.minecraft.brick": "红砖",
  "item.minecraft.brown_bundle": "棕色收纳袋",
  "item.minecraft.brown_dye": "棕色染料",
  "item.minecraft.brown_egg": "棕色鸡蛋",
  "item.minecraft.brown_harness": "棕色挽具",
  "item.minecraft.brush": "刷子",
  "item.minecraft.bucket": "铁桶",
  "item.minecraft.bundle": "收纳袋",
  "item.minecraft.bundle.empty": "空",
  "item.minecraft.bundle.empty.description": "可容纳一组混合的物品",
  "item.minecraft.bundle.full": "满",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "烈焰纹样陶片",
  "item.minecraft.burn_pottery_sherd": "烈焰纹样陶片",
  "item.minecraft.camel_husk_spawn_egg": "骆驼尸壳刷怪蛋",
  "item.minecraft.camel_spawn_egg": "骆驼刷怪蛋",
  "item.minecraft.carrot": "胡萝卜",
  "item.minecraft.carrot_on_a_stick": "胡萝卜钓竿",
  "item.minecraft.cat_spawn_egg": "猫刷怪蛋",
  "item.minecraft.cauldron": "炼药锅",
  "item.minecraft.cave_spider_spawn_egg": "洞穴蜘蛛刷怪蛋",
  "item.minecraft.chainmail_boots": "锁链靴子",
  "item.minecraft.chainmail_chestplate": "锁链胸甲",
  "item.minecraft.chainmail_helmet": "锁链头盔",
  "item.minecraft.chainmail_leggings": "锁链护腿",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.cherry_boat": "樱花木船",
  "item.minecraft.cherry_chest_boat": "樱花木运输船",
  "item.minecraft.chest_minecart": "运输矿车",
  "item.minecraft.chicken": "生鸡肉",
  "item.minecraft.chicken_spawn_egg": "鸡刷怪蛋",
  "item.minecraft.chorus_fruit": "紫颂果",
  "item.minecraft.clay_ball": "黏土球",
  "item.minecraft.clock": "时钟",
  "item.minecraft.coal": "煤炭",
  "item.minecraft.coast_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.coast_armor_trim_smithing_template.new": "海岸盔甲纹饰",
  "item.minecraft.cocoa_beans": "可可豆",
  "item.minecraft.cod": "生鳕鱼",
  "item.minecraft.cod_bucket": "鳕鱼桶",
  "item.minecraft.cod_spawn_egg": "鳕鱼刷怪蛋",
  "item.minecraft.command_block_minecart": "命令方块矿车",
  "item.minecraft.compass": "指南针",
  "item.minecraft.cooked_beef": "牛排",
  "item.minecraft.cooked_chicken": "熟鸡肉",
  "item.minecraft.cooked_cod": "熟鳕鱼",
  "item.minecraft.cooked_mutton": "熟羊肉",
  "item.minecraft.cooked_porkchop": "熟猪排",
  "item.minecraft.cooked_rabbit": "熟兔肉",
  "item.minecraft.cooked_salmon": "熟鲑鱼",
  "item.minecraft.cookie": "曲奇",
  "item.minecraft.copper_axe": "铜斧",
  "item.minecraft.copper_boots": "铜靴子",
  "item.minecraft.copper_chestplate": "铜胸甲",
  "item.minecraft.copper_golem_spawn_egg": "铜傀儡刷怪蛋",
  "item.minecraft.copper_helmet": "铜头盔",
  "item.minecraft.copper_hoe": "铜锄",
  "item.minecraft.copper_horse_armor": "铜马铠",
  "item.minecraft.copper_ingot": "铜锭",
  "item.minecraft.copper_leggings": "铜护腿",
  "item.minecraft.copper_nautilus_armor": "铜鹦鹉螺铠",
  "item.minecraft.copper_nugget": "铜粒",
  "item.minecraft.copper_pickaxe": "铜镐",
  "item.minecraft.copper_shovel": "铜锹",
  "item.minecraft.copper_spear": "铜矛",
  "item.minecraft.copper_sword": "铜剑",
  "item.minecraft.cow_spawn_egg": "牛刷怪蛋",
  "item.minecraft.creaking_spawn_egg": "嘎枝刷怪蛋",
  "item.minecraft.creeper_banner_pattern": "旗帜图案",
  "item.minecraft.creeper_banner_pattern.desc": "苦力怕盾徽",
  "item.minecraft.creeper_banner_pattern.new": "苦力怕盾徽旗帜图案",
  "item.minecraft.creeper_spawn_egg": "苦力怕刷怪蛋",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.crossbow.projectile": "弹射物：",
  "item.minecraft.crossbow.projectile.multiple": "弹射物：%s × %s",
  "item.minecraft.crossbow.projectile.single": "弹射物：%s",
  "item.minecraft.cyan_bundle": "青色收纳袋",
  "item.minecraft.cyan_dye": "青色染料",
  "item.minecraft.cyan_harness": "青色挽具",
  "item.minecraft.danger_pottery_shard": "危机纹样陶片",
  "item.minecraft.danger_pottery_sherd": "危机纹样陶片",
  "item.minecraft.dark_oak_boat": "深色橡木船",
  "item.minecraft.dark_oak_chest_boat": "深色橡木运输船",
  "item.minecraft.debug_stick": "调试棒",
  "item.minecraft.debug_stick.empty": "%s不具备属性",
  "item.minecraft.debug_stick.select": "已选择“%s”（%s）",
  "item.minecraft.debug_stick.update": "“%s”设为%s",
  "item.minecraft.diamond": "钻石",
  "item.minecraft.diamond_axe": "钻石斧",
  "item.minecraft.diamond_boots": "钻石靴子",
  "item.minecraft.diamond_chestplate": "钻石胸甲",
  "item.minecraft.diamond_helmet": "钻石头盔",
  "item.minecraft.diamond_hoe": "钻石锄",
  "item.minecraft.diamond_horse_armor": "钻石马铠",
  "item.minecraft.diamond_leggings": "钻石护腿",
  "item.minecraft.diamond_nautilus_armor": "钻石鹦鹉螺铠",
  "item.minecraft.diamond_pickaxe": "钻石镐",
  "item.minecraft.diamond_shovel": "钻石锹",
  "item.minecraft.diamond_spear": "钻石矛",
  "item.minecraft.diamond_sword": "钻石剑",
  "item.minecraft.disc_fragment_5": "唱片残片",
  "item.minecraft.disc_fragment_5.desc": "音乐唱片 - 5",
  "item.minecraft.dolphin_spawn_egg": "海豚刷怪蛋",
  "item.minecraft.donkey_spawn_egg": "驴刷怪蛋",
  "item.minecraft.dragon_breath": "龙息",
  "item.minecraft.dried_kelp": "干海带",
  "item.minecraft.drowned_spawn_egg": "溺尸刷怪蛋",
  "item.minecraft.dune_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.dune_armor_trim_smithing_template.new": "沙丘盔甲纹饰",
  "item.minecraft.echo_shard": "回响碎片",
  "item.minecraft.egg": "鸡蛋",
  "item.minecraft.elder_guardian_spawn_egg": "远古守卫者刷怪蛋",
  "item.minecraft.elytra": "鞘翅",
  "item.minecraft.emerald": "绿宝石",
  "item.minecraft.enchanted_book": "附魔书",
  "item.minecraft.enchanted_golden_apple": "附魔金苹果",
  "item.minecraft.end_crystal": "末地水晶",
  "item.minecraft.ender_dragon_spawn_egg": "末影龙刷怪蛋",
  "item.minecraft.ender_eye": "末影之眼",
  "item.minecraft.ender_pearl": "末影珍珠",
  "item.minecraft.enderman_spawn_egg": "末影人刷怪蛋",
  "item.minecraft.endermite_spawn_egg": "末影螨刷怪蛋",
  "item.minecraft.evoker_spawn_egg": "唤魔者刷怪蛋",
  "item.minecraft.experience_bottle": "附魔之瓶",
  "item.minecraft.explorer_pottery_shard": "探险纹样陶片",
  "item.minecraft.explorer_pottery_sherd": "探险纹样陶片",
  "item.minecraft.eye_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.eye_armor_trim_smithing_template.new": "眼眸盔甲纹饰",
  "item.minecraft.feather": "羽毛",
  "item.minecraft.fermented_spider_eye": "发酵蛛眼",
  "item.minecraft.field_masoned_banner_pattern": "砖纹旗帜图案",
  "item.minecraft.filled_map": "地图",
  "item.minecraft.fire_charge": "火焰弹",
  "item.minecraft.firework_rocket": "烟花火箭",
  "item.minecraft.firework_rocket.flight": "飞行时间：",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "烟火之星",
  "item.minecraft.firework_star.black": "黑色",
  "item.minecraft.firework_star.blue": "蓝色",
  "item.minecraft.firework_star.brown": "棕色",
  "item.minecraft.firework_star.custom_color": "自定义",
  "item.minecraft.firework_star.cyan": "青色",
  "item.minecraft.firework_star.fade_to": "淡化至",
  "item.minecraft.firework_star.flicker": "闪烁",
  "item.minecraft.firework_star.gray": "灰色",
  "item.minecraft.firework_star.green": "绿色",
  "item.minecraft.firework_star.light_blue": "淡蓝色",
  "item.minecraft.firework_star.light_gray": "淡灰色",
  "item.minecraft.firework_star.lime": "黄绿色",
  "item.minecraft.firework_star.magenta": "品红色",
  "item.minecraft.firework_star.orange": "橙色",
  "item.minecraft.firework_star.pink": "粉红色",
  "item.minecraft.firework_star.purple": "紫色",
  "item.minecraft.firework_star.red": "红色",
  "item.minecraft.firework_star.shape": "未知形状",
  "item.minecraft.firework_star.shape.burst": "喷发状",
  "item.minecraft.firework_star.shape.creeper": "苦力怕状",
  "item.minecraft.firework_star.shape.large_ball": "大型球状",
  "item.minecraft.firework_star.shape.small_ball": "小型球状",
  "item.minecraft.firework_star.shape.star": "星形",
  "item.minecraft.firework_star.trail": "踪迹",
  "item.minecraft.firework_star.white": "白色",
  "item.minecraft.firework_star.yellow": "黄色",
  "item.minecraft.fishing_rod": "钓鱼竿",
  "item.minecraft.flint": "燧石",
  "item.minecraft.flint_and_steel": "打火石",
  "item.minecraft.flow_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.flow_armor_trim_smithing_template.new": "涡流盔甲纹饰",
  "item.minecraft.flow_banner_pattern": "旗帜图案",
  "item.minecraft.flow_banner_pattern.desc": "涡流",
  "item.minecraft.flow_banner_pattern.new": "涡流旗帜图案",
  "item.minecraft.flow_pottery_sherd": "涡流纹样陶片",
  "item.minecraft.flower_banner_pattern": "旗帜图案",
  "item.minecraft.flower_banner_pattern.desc": "花朵盾徽",
  "item.minecraft.flower_banner_pattern.new": "花朵盾徽旗帜图案",
  "item.minecraft.flower_pot": "花盆",
  "item.minecraft.fox_spawn_egg": "狐狸刷怪蛋",
  "item.minecraft.friend_pottery_shard": "挚友纹样陶片",
  "item.minecraft.friend_pottery_sherd": "挚友纹样陶片",
  "item.minecraft.frog_spawn_egg": "青蛙刷怪蛋",
  "item.minecraft.furnace_minecart": "动力矿车",
  "item.minecraft.ghast_spawn_egg": "恶魂刷怪蛋",
  "item.minecraft.ghast_tear": "恶魂之泪",
  "item.minecraft.glass_bottle": "玻璃瓶",
  "item.minecraft.glistering_melon_slice": "闪烁的西瓜片",
  "item.minecraft.globe_banner_pattern": "旗帜图案",
  "item.minecraft.globe_banner_pattern.desc": "地球",
  "item.minecraft.globe_banner_pattern.new": "地球旗帜图案",
  "item.minecraft.glow_berries": "发光浆果",
  "item.minecraft.glow_ink_sac": "荧光墨囊",
  "item.minecraft.glow_item_frame": "荧光物品展示框",
  "item.minecraft.glow_squid_spawn_egg": "发光鱿鱼刷怪蛋",
  "item.minecraft.glowstone_dust": "荧石粉",
  "item.minecraft.goat_horn": "山羊角",
  "item.minecraft.goat_spawn_egg": "山羊刷怪蛋",
  "item.minecraft.gold_ingot": "金锭",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.golden_apple": "金苹果",
  "item.minecraft.golden_axe": "金斧",
  "item.minecraft.golden_boots": "金靴子",
  "item.minecraft.golden_carrot": "金胡萝卜",
  "item.minecraft.golden_chestplate": "金胸甲",
  "item.minecraft.golden_helmet": "金头盔",
  "item.minecraft.golden_hoe": "金锄",
  "item.minecraft.golden_horse_armor": "金马铠",
  "item.minecraft.golden_leggings": "金护腿",
  "item.minecraft.golden_nautilus_armor": "金鹦鹉螺铠",
  "item.minecraft.golden_pickaxe": "金镐",
  "item.minecraft.golden_shovel": "金锹",
  "item.minecraft.golden_spear": "金矛",
  "item.minecraft.golden_sword": "金剑",
  "item.minecraft.gray_bundle": "灰色收纳袋",
  "item.minecraft.gray_dye": "灰色染料",
  "item.minecraft.gray_harness": "灰色挽具",
  "item.minecraft.green_bundle": "绿色收纳袋",
  "item.minecraft.green_dye": "绿色染料",
  "item.minecraft.green_harness": "绿色挽具",
  "item.minecraft.guardian_spawn_egg": "守卫者刷怪蛋",
  "item.minecraft.gunpowder": "火药",
  "item.minecraft.guster_banner_pattern": "旗帜图案",
  "item.minecraft.guster_banner_pattern.desc": "旋风",
  "item.minecraft.guster_banner_pattern.new": "旋风旗帜图案",
  "item.minecraft.guster_pottery_sherd": "旋风纹样陶片",
  "item.minecraft.happy_ghast_spawn_egg": "快乐恶魂刷怪蛋",
  "item.minecraft.harness": "挽具",
  "item.minecraft.heart_of_the_sea": "海洋之心",
  "item.minecraft.heart_pottery_shard": "爱心纹样陶片",
  "item.minecraft.heart_pottery_sherd": "爱心纹样陶片",
  "item.minecraft.heartbreak_pottery_shard": "心碎纹样陶片",
  "item.minecraft.heartbreak_pottery_sherd": "心碎纹样陶片",
  "item.minecraft.hoglin_spawn_egg": "疣猪兽刷怪蛋",
  "item.minecraft.honey_bottle": "蜂蜜瓶",
  "item.minecraft.honeycomb": "蜜脾",
  "item.minecraft.hopper_minecart": "漏斗矿车",
  "item.minecraft.horse_spawn_egg": "马刷怪蛋",
  "item.minecraft.host_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.host_armor_trim_smithing_template.new": "雇主盔甲纹饰",
  "item.minecraft.howl_pottery_shard": "狼嚎纹样陶片",
  "item.minecraft.howl_pottery_sherd": "狼嚎纹样陶片",
  "item.minecraft.husk_spawn_egg": "尸壳刷怪蛋",
  "item.minecraft.ink_sac": "墨囊",
  "item.minecraft.iron_axe": "铁斧",
  "item.minecraft.iron_boots": "铁靴子",
  "item.minecraft.iron_chestplate": "铁胸甲",
  "item.minecraft.iron_golem_spawn_egg": "铁傀儡刷怪蛋",
  "item.minecraft.iron_helmet": "铁头盔",
  "item.minecraft.iron_hoe": "铁锄",
  "item.minecraft.iron_horse_armor": "铁马铠",
  "item.minecraft.iron_ingot": "铁锭",
  "item.minecraft.iron_leggings": "铁护腿",
  "item.minecraft.iron_nautilus_armor": "铁鹦鹉螺铠",
  "item.minecraft.iron_nugget": "铁粒",
  "item.minecraft.iron_pickaxe": "铁镐",
  "item.minecraft.iron_shovel": "铁锹",
  "item.minecraft.iron_spear": "铁矛",
  "item.minecraft.iron_sword": "铁剑",
  "item.minecraft.item_frame": "物品展示框",
  "item.minecraft.jungle_boat": "丛林木船",
  "item.minecraft.jungle_chest_boat": "丛林木运输船",
  "item.minecraft.knowledge_book": "知识之书",
  "item.minecraft.lapis_lazuli": "青金石",
  "item.minecraft.lava_bucket": "熔岩桶",
  "item.minecraft.lead": "拴绳",
  "item.minecraft.leather": "皮革",
  "item.minecraft.leather_boots": "皮革靴子",
  "item.minecraft.leather_chestplate": "皮革外套",
  "item.minecraft.leather_helmet": "皮革帽子",
  "item.minecraft.leather_horse_armor": "皮革马铠",
  "item.minecraft.leather_leggings": "皮革裤子",
  "item.minecraft.light_blue_bundle": "淡蓝色收纳袋",
  "item.minecraft.light_blue_dye": "淡蓝色染料",
  "item.minecraft.light_blue_harness": "淡蓝色挽具",
  "item.minecraft.light_gray_bundle": "淡灰色收纳袋",
  "item.minecraft.light_gray_dye": "淡灰色染料",
  "item.minecraft.light_gray_harness": "淡灰色挽具",
  "item.minecraft.lime_bundle": "黄绿色收纳袋",
  "item.minecraft.lime_dye": "黄绿色染料",
  "item.minecraft.lime_harness": "黄绿色挽具",
  "item.minecraft.lingering_potion": "滞留药水",
  "item.minecraft.lingering_potion.effect.awkward": "滞留型粗制的药水",
  "item.minecraft.lingering_potion.effect.empty": "不可合成的滞留型药水",
  "item.minecraft.lingering_potion.effect.fire_resistance": "滞留型抗火药水",
  "item.minecraft.lingering_potion.effect.harming": "滞留型伤害药水",
  "item.minecraft.lingering_potion.effect.healing": "滞留型治疗药水",
  "item.minecraft.lingering_potion.effect.infested": "滞留型虫蚀药水",
  "item.minecraft.lingering_potion.effect.invisibility": "滞留型隐身药水",
  "item.minecraft.lingering_potion.effect.leaping": "滞留型跳跃药水",
  "item.minecraft.lingering_potion.effect.levitation": "滞留型飘浮药水",
  "item.minecraft.lingering_potion.effect.luck": "滞留型幸运药水",
  "item.minecraft.lingering_potion.effect.mundane": "滞留型平凡的药水",
  "item.minecraft.lingering_potion.effect.night_vision": "滞留型夜视药水",
  "item.minecraft.lingering_potion.effect.oozing": "滞留型渗浆药水",
  "item.minecraft.lingering_potion.effect.poison": "滞留型剧毒药水",
  "item.minecraft.lingering_potion.effect.regeneration": "滞留型再生药水",
  "item.minecraft.lingering_potion.effect.slow_falling": "滞留型缓降药水",
  "item.minecraft.lingering_potion.effect.slowness": "滞留型迟缓药水",
  "item.minecraft.lingering_potion.effect.strength": "滞留型力量药水",
  "item.minecraft.lingering_potion.effect.swiftness": "滞留型迅捷药水",
  "item.minecraft.lingering_potion.effect.thick": "滞留型浓稠的药水",
  "item.minecraft.lingering_potion.effect.turtle_master": "滞留型神龟药水",
  "item.minecraft.lingering_potion.effect.water": "滞留型水瓶",
  "item.minecraft.lingering_potion.effect.water_breathing": "滞留型水肺药水",
  "item.minecraft.lingering_potion.effect.weakness": "滞留型虚弱药水",
  "item.minecraft.lingering_potion.effect.weaving": "滞留型盘丝药水",
  "item.minecraft.lingering_potion.effect.wind_charged": "滞留型蓄风药水",
  "item.minecraft.llama_spawn_egg": "羊驼刷怪蛋",
  "item.minecraft.lodestone_compass": "磁石指针",
  "item.minecraft.mace": "重锤",
  "item.minecraft.magenta_bundle": "品红色收纳袋",
  "item.minecraft.magenta_dye": "品红色染料",
  "item.minecraft.magenta_harness": "品红色挽具",
  "item.minecraft.magma_cream": "岩浆膏",
  "item.minecraft.magma_cube_spawn_egg": "岩浆怪刷怪蛋",
  "item.minecraft.mangrove_boat": "红树木船",
  "item.minecraft.mangrove_chest_boat": "红树木运输船",
  "item.minecraft.map": "空地图",
  "item.minecraft.melon_seeds": "西瓜种子",
  "item.minecraft.melon_slice": "西瓜片",
  "item.minecraft.milk_bucket": "奶桶",
  "item.minecraft.minecart": "矿车",
  "item.minecraft.miner_pottery_shard": "采矿纹样陶片",
  "item.minecraft.miner_pottery_sherd": "采矿纹样陶片",
  "item.minecraft.mojang_banner_pattern": "旗帜图案",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang徽标",
  "item.minecraft.mojang_banner_pattern.new": "Mojang徽标旗帜图案",
  "item.minecraft.mooshroom_spawn_egg": "哞菇刷怪蛋",
  "item.minecraft.mourner_pottery_shard": "悲恸纹样陶片",
  "item.minecraft.mourner_pottery_sherd": "悲恸纹样陶片",
  "item.minecraft.mule_spawn_egg": "骡刷怪蛋",
  "item.minecraft.mushroom_stew": "蘑菇煲",
  "item.minecraft.music_disc_11": "音乐唱片",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "音乐唱片",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "音乐唱片",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "音乐唱片",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "音乐唱片",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "音乐唱片",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "音乐唱片",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "音乐唱片",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator（八音盒）",
  "item.minecraft.music_disc_far": "音乐唱片",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "音乐唱片",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "音乐唱片",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "音乐唱片",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "音乐唱片",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "音乐唱片",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "音乐唱片",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "音乐唱片",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "音乐唱片",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "音乐唱片",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "音乐唱片",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "音乐唱片",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "音乐唱片",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.name_tag": "命名牌",
  "item.minecraft.nautilus_shell": "鹦鹉螺壳",
  "item.minecraft.nautilus_spawn_egg": "鹦鹉螺刷怪蛋",
  "item.minecraft.nether_brick": "下界砖",
  "item.minecraft.nether_star": "下界之星",
  "item.minecraft.nether_wart": "下界疣",
  "item.minecraft.netherite_axe": "下界合金斧",
  "item.minecraft.netherite_boots": "下界合金靴子",
  "item.minecraft.netherite_chestplate": "下界合金胸甲",
  "item.minecraft.netherite_helmet": "下界合金头盔",
  "item.minecraft.netherite_hoe": "下界合金锄",
  "item.minecraft.netherite_horse_armor": "下界合金马铠",
  "item.minecraft.netherite_ingot": "下界合金锭",
  "item.minecraft.netherite_leggings": "下界合金护腿",
  "item.minecraft.netherite_nautilus_armor": "下界合金鹦鹉螺铠",
  "item.minecraft.netherite_pickaxe": "下界合金镐",
  "item.minecraft.netherite_scrap": "下界合金碎片",
  "item.minecraft.netherite_shovel": "下界合金锹",
  "item.minecraft.netherite_spear": "下界合金矛",
  "item.minecraft.netherite_sword": "下界合金剑",
  "item.minecraft.netherite_upgrade_smithing_template": "锻造模板",
  "item.minecraft.netherite_upgrade_smithing_template.new": "下界合金升级",
  "item.minecraft.oak_boat": "橡木船",
  "item.minecraft.oak_chest_boat": "橡木运输船",
  "item.minecraft.ocelot_spawn_egg": "豹猫刷怪蛋",
  "item.minecraft.ominous_bottle": "不祥之瓶",
  "item.minecraft.ominous_trial_key": "不祥试炼钥匙",
  "item.minecraft.orange_bundle": "橙色收纳袋",
  "item.minecraft.orange_dye": "橙色染料",
  "item.minecraft.orange_harness": "橙色挽具",
  "item.minecraft.painting": "画",
  "item.minecraft.pale_oak_boat": "苍白橡木船",
  "item.minecraft.pale_oak_chest_boat": "苍白橡木运输船",
  "item.minecraft.panda_spawn_egg": "熊猫刷怪蛋",
  "item.minecraft.paper": "纸",
  "item.minecraft.parched_spawn_egg": "焦骸刷怪蛋",
  "item.minecraft.parrot_spawn_egg": "鹦鹉刷怪蛋",
  "item.minecraft.phantom_membrane": "幻翼膜",
  "item.minecraft.phantom_spawn_egg": "幻翼刷怪蛋",
  "item.minecraft.pig_spawn_egg": "猪刷怪蛋",
  "item.minecraft.piglin_banner_pattern": "旗帜图案",
  "item.minecraft.piglin_banner_pattern.desc": "猪鼻",
  "item.minecraft.piglin_banner_pattern.new": "猪鼻旗帜图案",
  "item.minecraft.piglin_brute_spawn_egg": "猪灵蛮兵刷怪蛋",
  "item.minecraft.piglin_spawn_egg": "猪灵刷怪蛋",
  "item.minecraft.pillager_spawn_egg": "掠夺者刷怪蛋",
  "item.minecraft.pink_bundle": "粉红色收纳袋",
  "item.minecraft.pink_dye": "粉红色染料",
  "item.minecraft.pink_harness": "粉红色挽具",
  "item.minecraft.pitcher_plant": "瓶子草",
  "item.minecraft.pitcher_pod": "瓶子草荚果",
  "item.minecraft.plenty_pottery_shard": "富饶纹样陶片",
  "item.minecraft.plenty_pottery_sherd": "富饶纹样陶片",
  "item.minecraft.poisonous_potato": "毒马铃薯",
  "item.minecraft.polar_bear_spawn_egg": "北极熊刷怪蛋",
  "item.minecraft.popped_chorus_fruit": "爆裂紫颂果",
  "item.minecraft.porkchop": "生猪排",
  "item.minecraft.potato": "马铃薯",
  "item.minecraft.potion": "药水",
  "item.minecraft.potion.effect.awkward": "粗制的药水",
  "item.minecraft.potion.effect.empty": "不可合成的药水",
  "item.minecraft.potion.effect.fire_resistance": "抗火药水",
  "item.minecraft.potion.effect.harming": "伤害药水",
  "item.minecraft.potion.effect.healing": "治疗药水",
  "item.minecraft.potion.effect.infested": "虫蚀药水",
  "item.minecraft.potion.effect.invisibility": "隐身药水",
  "item.minecraft.potion.effect.leaping": "跳跃药水",
  "item.minecraft.potion.effect.levitation": "飘浮药水",
  "item.minecraft.potion.effect.luck": "幸运药水",
  "item.minecraft.potion.effect.mundane": "平凡的药水",
  "item.minecraft.potion.effect.night_vision": "夜视药水",
  "item.minecraft.potion.effect.oozing": "渗浆药水",
  "item.minecraft.potion.effect.poison": "剧毒药水",
  "item.minecraft.potion.effect.regeneration": "再生药水",
  "item.minecraft.potion.effect.slow_falling": "缓降药水",
  "item.minecraft.potion.effect.slowness": "迟缓药水",
  "item.minecraft.potion.effect.strength": "力量药水",
  "item.minecraft.potion.effect.swiftness": "迅捷药水",
  "item.minecraft.potion.effect.thick": "浓稠的药水",
  "item.minecraft.potion.effect.turtle_master": "神龟药水",
  "item.minecraft.potion.effect.water": "水瓶",
  "item.minecraft.potion.effect.water_breathing": "水肺药水",
  "item.minecraft.potion.effect.weakness": "虚弱药水",
  "item.minecraft.potion.effect.weaving": "盘丝药水",
  "item.minecraft.potion.effect.wind_charged": "蓄风药水",
  "item.minecraft.pottery_shard_archer": "弓箭纹样陶片",
  "item.minecraft.pottery_shard_arms_up": "举臂纹样陶片",
  "item.minecraft.pottery_shard_prize": "珍宝纹样陶片",
  "item.minecraft.pottery_shard_skull": "头颅纹样陶片",
  "item.minecraft.powder_snow_bucket": "细雪桶",
  "item.minecraft.prismarine_crystals": "海晶砂粒",
  "item.minecraft.prismarine_shard": "海晶碎片",
  "item.minecraft.prize_pottery_shard": "珍宝纹样陶片",
  "item.minecraft.prize_pottery_sherd": "珍宝纹样陶片",
  "item.minecraft.pufferfish": "河豚",
  "item.minecraft.pufferfish_bucket": "河豚桶",
  "item.minecraft.pufferfish_spawn_egg": "河豚刷怪蛋",
  "item.minecraft.pumpkin_pie": "南瓜派",
  "item.minecraft.pumpkin_seeds": "南瓜种子",
  "item.minecraft.purple_bundle": "紫色收纳袋",
  "item.minecraft.purple_dye": "紫色染料",
  "item.minecraft.purple_harness": "紫色挽具",
  "item.minecraft.quartz": "下界石英",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.rabbit_foot": "兔子脚",
  "item.minecraft.rabbit_hide": "兔子皮",
  "item.minecraft.rabbit_spawn_egg": "兔子刷怪蛋",
  "item.minecraft.rabbit_stew": "兔肉煲",
  "item.minecraft.raiser_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "牧民盔甲纹饰",
  "item.minecraft.ravager_spawn_egg": "劫掠兽刷怪蛋",
  "item.minecraft.raw_copper": "粗铜",
  "item.minecraft.raw_gold": "粗金",
  "item.minecraft.raw_iron": "粗铁",
  "item.minecraft.recovery_compass": "追溯指针",
  "item.minecraft.red_bundle": "红色收纳袋",
  "item.minecraft.red_dye": "红色染料",
  "item.minecraft.red_harness": "红色挽具",
  "item.minecraft.redstone": "红石粉",
  "item.minecraft.resin_brick": "树脂砖",
  "item.minecraft.resin_clump": "树脂团",
  "item.minecraft.rib_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.rib_armor_trim_smithing_template.new": "肋骨盔甲纹饰",
  "item.minecraft.rotten_flesh": "腐肉",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.salmon": "生鲑鱼",
  "item.minecraft.salmon_bucket": "鲑鱼桶",
  "item.minecraft.salmon_spawn_egg": "鲑鱼刷怪蛋",
  "item.minecraft.scrape_pottery_sherd": "刮削纹样陶片",
  "item.minecraft.scute": "鳞甲",
  "item.minecraft.sentry_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "哨兵盔甲纹饰",
  "item.minecraft.shaper_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "塑造盔甲纹饰",
  "item.minecraft.sheaf_pottery_shard": "麦捆纹样陶片",
  "item.minecraft.sheaf_pottery_sherd": "麦捆纹样陶片",
  "item.minecraft.shears": "剪刀",
  "item.minecraft.sheep_spawn_egg": "绵羊刷怪蛋",
  "item.minecraft.shelter_pottery_shard": "树荫纹样陶片",
  "item.minecraft.shelter_pottery_sherd": "树荫纹样陶片",
  "item.minecraft.shield": "盾牌",
  "item.minecraft.shield.black": "黑色盾牌",
  "item.minecraft.shield.blue": "蓝色盾牌",
  "item.minecraft.shield.brown": "棕色盾牌",
  "item.minecraft.shield.cyan": "青色盾牌",
  "item.minecraft.shield.gray": "灰色盾牌",
  "item.minecraft.shield.green": "绿色盾牌",
  "item.minecraft.shield.light_blue": "淡蓝色盾牌",
  "item.minecraft.shield.light_gray": "淡灰色盾牌",
  "item.minecraft.shield.lime": "黄绿色盾牌",
  "item.minecraft.shield.magenta": "品红色盾牌",
  "item.minecraft.shield.orange": "橙色盾牌",
  "item.minecraft.shield.pink": "粉红色盾牌",
  "item.minecraft.shield.purple": "紫色盾牌",
  "item.minecraft.shield.red": "红色盾牌",
  "item.minecraft.shield.white": "白色盾牌",
  "item.minecraft.shield.yellow": "黄色盾牌",
  "item.minecraft.shulker_shell": "潜影壳",
  "item.minecraft.shulker_spawn_egg": "潜影贝刷怪蛋",
  "item.minecraft.sign": "告示牌",
  "item.minecraft.silence_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.silence_armor_trim_smithing_template.new": "幽静盔甲纹饰",
  "item.minecraft.silverfish_spawn_egg": "蠹虫刷怪蛋",
  "item.minecraft.skeleton_horse_spawn_egg": "骷髅马刷怪蛋",
  "item.minecraft.skeleton_spawn_egg": "骷髅刷怪蛋",
  "item.minecraft.skull_banner_pattern": "旗帜图案",
  "item.minecraft.skull_banner_pattern.desc": "头颅盾徽",
  "item.minecraft.skull_banner_pattern.new": "头颅盾徽旗帜图案",
  "item.minecraft.skull_pottery_shard": "头颅纹样陶片",
  "item.minecraft.skull_pottery_sherd": "头颅纹样陶片",
  "item.minecraft.slime_ball": "黏液球",
  "item.minecraft.slime_spawn_egg": "史莱姆刷怪蛋",
  "item.minecraft.smithing_template": "锻造模板",
  "item.minecraft.smithing_template.applies_to": "可应用于：",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "放入锭或晶体",
  "item.minecraft.smithing_template.armor_trim.applies_to": "盔甲",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "放入盔甲",
  "item.minecraft.smithing_template.armor_trim.ingredients": "锭或晶体",
  "item.minecraft.smithing_template.ingredients": "所需原材料：",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "放入下界合金锭",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "钻石装备",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "放入钻石盔甲、武器或工具",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "下界合金锭",
  "item.minecraft.smithing_template.upgrade": "已有升级：",
  "item.minecraft.sniffer_spawn_egg": "嗅探兽刷怪蛋",
  "item.minecraft.snort_pottery_shard": "嗅探纹样陶片",
  "item.minecraft.snort_pottery_sherd": "嗅探纹样陶片",
  "item.minecraft.snout_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.snout_armor_trim_smithing_template.new": "猪鼻盔甲纹饰",
  "item.minecraft.snow_golem_spawn_egg": "雪傀儡刷怪蛋",
  "item.minecraft.snowball": "雪球",
  "item.minecraft.spectral_arrow": "光灵箭",
  "item.minecraft.spider_eye": "蜘蛛眼",
  "item.minecraft.spider_spawn_egg": "蜘蛛刷怪蛋",
  "item.minecraft.spire_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.spire_armor_trim_smithing_template.new": "尖塔盔甲纹饰",
  "item.minecraft.splash_potion": "喷溅药水",
  "item.minecraft.splash_potion.effect.awkward": "喷溅型粗制的药水",
  "item.minecraft.splash_potion.effect.empty": "不可合成的喷溅型药水",
  "item.minecraft.splash_potion.effect.fire_resistance": "喷溅型抗火药水",
  "item.minecraft.splash_potion.effect.harming": "喷溅型伤害药水",
  "item.minecraft.splash_potion.effect.healing": "喷溅型治疗药水",
  "item.minecraft.splash_potion.effect.infested": "喷溅型虫蚀药水",
  "item.minecraft.splash_potion.effect.invisibility": "喷溅型隐身药水",
  "item.minecraft.splash_potion.effect.leaping": "喷溅型跳跃药水",
  "item.minecraft.splash_potion.effect.levitation": "喷溅型飘浮药水",
  "item.minecraft.splash_potion.effect.luck": "喷溅型幸运药水",
  "item.minecraft.splash_potion.effect.mundane": "喷溅型平凡的药水",
  "item.minecraft.splash_potion.effect.night_vision": "喷溅型夜视药水",
  "item.minecraft.splash_potion.effect.oozing": "喷溅型渗浆药水",
  "item.minecraft.splash_potion.effect.poison": "喷溅型剧毒药水",
  "item.minecraft.splash_potion.effect.regeneration": "喷溅型再生药水",
  "item.minecraft.splash_potion.effect.slow_falling": "喷溅型缓降药水",
  "item.minecraft.splash_potion.effect.slowness": "喷溅型迟缓药水",
  "item.minecraft.splash_potion.effect.strength": "喷溅型力量药水",
  "item.minecraft.splash_potion.effect.swiftness": "喷溅型迅捷药水",
  "item.minecraft.splash_potion.effect.thick": "喷溅型浓稠的药水",
  "item.minecraft.splash_potion.effect.turtle_master": "喷溅型神龟药水",
  "item.minecraft.splash_potion.effect.water": "喷溅型水瓶",
  "item.minecraft.splash_potion.effect.water_breathing": "喷溅型水肺药水",
  "item.minecraft.splash_potion.effect.weakness": "喷溅型虚弱药水",
  "item.minecraft.splash_potion.effect.weaving": "喷溅型盘丝药水",
  "item.minecraft.splash_potion.effect.wind_charged": "喷溅型蓄风药水",
  "item.minecraft.spruce_boat": "云杉木船",
  "item.minecraft.spruce_chest_boat": "云杉木运输船",
  "item.minecraft.spyglass": "望远镜",
  "item.minecraft.squid_spawn_egg": "鱿鱼刷怪蛋",
  "item.minecraft.stick": "木棍",
  "item.minecraft.stone_axe": "石斧",
  "item.minecraft.stone_hoe": "石锄",
  "item.minecraft.stone_pickaxe": "石镐",
  "item.minecraft.stone_shovel": "石锹",
  "item.minecraft.stone_spear": "石矛",
  "item.minecraft.stone_sword": "石剑",
  "item.minecraft.stray_spawn_egg": "流浪者刷怪蛋",
  "item.minecraft.strider_spawn_egg": "炽足兽刷怪蛋",
  "item.minecraft.string": "线",
  "item.minecraft.sugar": "糖",
  "item.minecraft.suspicious_stew": "谜之炖菜",
  "item.minecraft.sweet_berries": "甜浆果",
  "item.minecraft.tadpole_bucket": "蝌蚪桶",
  "item.minecraft.tadpole_spawn_egg": "蝌蚪刷怪蛋",
  "item.minecraft.tide_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.tide_armor_trim_smithing_template.new": "潮汐盔甲纹饰",
  "item.minecraft.tipped_arrow": "药箭",
  "item.minecraft.tipped_arrow.effect.awkward": "药箭",
  "item.minecraft.tipped_arrow.effect.empty": "不可合成的药箭",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "抗火之箭",
  "item.minecraft.tipped_arrow.effect.harming": "伤害之箭",
  "item.minecraft.tipped_arrow.effect.healing": "治疗之箭",
  "item.minecraft.tipped_arrow.effect.infested": "虫蚀之箭",
  "item.minecraft.tipped_arrow.effect.invisibility": "隐身之箭",
  "item.minecraft.tipped_arrow.effect.leaping": "跳跃之箭",
  "item.minecraft.tipped_arrow.effect.levitation": "飘浮之箭",
  "item.minecraft.tipped_arrow.effect.luck": "幸运之箭",
  "item.minecraft.tipped_arrow.effect.mundane": "药箭",
  "item.minecraft.tipped_arrow.effect.night_vision": "夜视之箭",
  "item.minecraft.tipped_arrow.effect.oozing": "渗浆之箭",
  "item.minecraft.tipped_arrow.effect.poison": "剧毒之箭",
  "item.minecraft.tipped_arrow.effect.regeneration": "再生之箭",
  "item.minecraft.tipped_arrow.effect.slow_falling": "缓降之箭",
  "item.minecraft.tipped_arrow.effect.slowness": "迟缓之箭",
  "item.minecraft.tipped_arrow.effect.strength": "力量之箭",
  "item.minecraft.tipped_arrow.effect.swiftness": "迅捷之箭",
  "item.minecraft.tipped_arrow.effect.thick": "药箭",
  "item.minecraft.tipped_arrow.effect.turtle_master": "神龟之箭",
  "item.minecraft.tipped_arrow.effect.water": "喷溅之箭",
  "item.minecraft.tipped_arrow.effect.water_breathing": "水肺之箭",
  "item.minecraft.tipped_arrow.effect.weakness": "虚弱之箭",
  "item.minecraft.tipped_arrow.effect.weaving": "盘丝之箭",
  "item.minecraft.tipped_arrow.effect.wind_charged": "蓄风之箭",
  "item.minecraft.tnt_minecart": "TNT矿车",
  "item.minecraft.torchflower_seeds": "火把花种子",
  "item.minecraft.totem_of_undying": "不死图腾",
  "item.minecraft.trader_llama_spawn_egg": "行商羊驼刷怪蛋",
  "item.minecraft.trial_key": "试炼钥匙",
  "item.minecraft.trident": "三叉戟",
  "item.minecraft.tropical_fish": "热带鱼",
  "item.minecraft.tropical_fish_bucket": "热带鱼桶",
  "item.minecraft.tropical_fish_spawn_egg": "热带鱼刷怪蛋",
  "item.minecraft.turtle_helmet": "海龟壳",
  "item.minecraft.turtle_scute": "海龟鳞甲",
  "item.minecraft.turtle_spawn_egg": "海龟刷怪蛋",
  "item.minecraft.vex_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.vex_armor_trim_smithing_template.new": "恼鬼盔甲纹饰",
  "item.minecraft.vex_spawn_egg": "恼鬼刷怪蛋",
  "item.minecraft.villager_spawn_egg": "村民刷怪蛋",
  "item.minecraft.vindicator_spawn_egg": "卫道士刷怪蛋",
  "item.minecraft.wandering_trader_spawn_egg": "流浪商人刷怪蛋",
  "item.minecraft.ward_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.ward_armor_trim_smithing_template.new": "监守盔甲纹饰",
  "item.minecraft.warden_spawn_egg": "监守者刷怪蛋",
  "item.minecraft.warped_fungus_on_a_stick": "诡异菌钓竿",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "向导盔甲纹饰",
  "item.minecraft.wheat": "小麦",
  "item.minecraft.wheat_seeds": "小麦种子",
  "item.minecraft.white_bundle": "白色收纳袋",
  "item.minecraft.white_dye": "白色染料",
  "item.minecraft.white_harness": "白色挽具",
  "item.minecraft.wild_armor_trim_smithing_template": "锻造模板",
  "item.minecraft.wild_armor_trim_smithing_template.new": "荒野盔甲纹饰",
  "item.minecraft.wind_charge": "风弹",
  "item.minecraft.witch_spawn_egg": "女巫刷怪蛋",
  "item.minecraft.wither_skeleton_spawn_egg": "凋灵骷髅刷怪蛋",
  "item.minecraft.wither_spawn_egg": "凋灵刷怪蛋",
  "item.minecraft.wolf_armor": "狼铠",
  "item.minecraft.wolf_spawn_egg": "狼刷怪蛋",
  "item.minecraft.wooden_axe": "木斧",
  "item.minecraft.wooden_hoe": "木锄",
  "item.minecraft.wooden_pickaxe": "木镐",
  "item.minecraft.wooden_shovel": "木锹",
  "item.minecraft.wooden_spear": "木矛",
  "item.minecraft.wooden_sword": "木剑",
  "item.minecraft.writable_book": "书与笔",
  "item.minecraft.written_book": "成书",
  "item.minecraft.yellow_bundle": "黄色收纳袋",
  "item.minecraft.yellow_dye": "黄色染料",
  "item.minecraft.yellow_harness": "黄色挽具",
  "item.minecraft.zoglin_spawn_egg": "僵尸疣猪兽刷怪蛋",
  "item.minecraft.zombie_horse_spawn_egg": "僵尸马刷怪蛋",
  "item.minecraft.zombie_nautilus_spawn_egg": "僵尸鹦鹉螺刷怪蛋",
  "item.minecraft.zombie_spawn_egg": "僵尸刷怪蛋",
  "item.minecraft.zombie_villager_spawn_egg": "僵尸村民刷怪蛋",
  "item.minecraft.zombified_piglin_spawn_egg": "僵尸猪灵刷怪蛋"
}
export const zh_cn = items; 
